import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {createI18n} from "@/i18n";
import {DistrictProBold} from "@/assets/webfonts/DistrictPro-Bold.js";
import {DistrictProMedium} from "@/assets/webfonts/DistrictPro-Medium.js";
import {DistrictProLight} from "@/assets/webfonts/DistrictPro-Light.js";

const moment = require("moment-timezone");

export default {
  install(Vue, { store, i18n }) {
    const helpers = new Helpers(store, i18n);
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  }
};

class Helpers {
  constructor(store, i18n) {
    this.store = store;
    this.i18n = i18n;
  }

  get locale() {
    return this.i18n.locale || 'de';
  }

  log(src, info, obj = null, splitArray = true) {
    console.log((src ? src.$options.name : "$helpers.log()") + " :: " + info);
    if (obj) {
      if (splitArray && Array.isArray(obj)) {
        obj.forEach((o) => {
          console.log(o);
        });
      } else {
        console.log(obj);
      }
    }
  }

  GetUiDataMap(force = false) {
    console.log("GetUiDataMap");
    if (this.store.state.uiDataMap && this.store.state.uiDataMapState && this.store.state.uiDataMapState.companyId == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        console.log(this.store.state.uiDataMap);
        resolve(this.store.state.uiDataMap);
      });
    } else {
      return this.GetCall("/api/sec/proxy/md/uidata")
        .then((response) => {
          var map = response.data[0];
          this.store.commit("setUiDataMap", {
            uiDataMap: map
          });
          return new Promise((resolve, reject) => {
            console.log(map);
            resolve(map);
          });
        })
        .catch((e) => {
          console.log(e);
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  LoadEnums(force = false) {
    console.log("LoadEnums");
    this.GetCountryEnum(force);
    this.GetCountryStateEnum(force);
    this.GetGenderEnum(force);
    this.GetCitizentypeEnum(force);
    this.GetCivilstatusEnum(force);
  }

  GetCountryEnum(force = false) {
    console.log("GetCountryEnum");
    if (this.store.state.countryEnumMap && this.store.state.countryEnumMapState && this.store.state.countryEnumMapState.companyId == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        console.log(this.store.state.countryEnumMap);
        resolve(this.store.state.countryEnumMap);
      });
    } else {
      return this.GetCall("/api/enum/country")
        .then((response) => {
          var map = response.data;
          this.store.commit("setCountryEnumMap", {
            countryEnumMap: map
          });
          return new Promise((resolve, reject) => {
            console.log(map);
            resolve(map);
          });
        })
        .catch((e) => {
          console.log(e);
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  GetCountryStateEnum(force = false) {
    console.log("GetCountryStateEnum");
    if (this.store.state.countryStateEnumMap && this.store.state.countryStateEnumMapState && this.store.state.countryStateEnumMapState.companyId == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        console.log(this.store.state.countryStateEnumMap);
        resolve(this.store.state.countryStateEnumMap);
      });
    } else {
      return this.GetCall("/api/enum/countrystate")
        .then((response) => {
          var map = response.data;
          this.store.commit("setCountryStateEnumMap", {
            countryStateEnumMap: map
          });
          return new Promise((resolve, reject) => {
            console.log(map);
            resolve(map);
          });
        })
        .catch((e) => {
          console.log(e);
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  GetGenderEnum(force = false) {
    console.log("GetGenderEnum");
    if (this.store.state.genderEnumMap && this.store.state.genderEnumMapState && this.store.state.genderEnumMapState.companyId == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        console.log(this.store.state.genderEnumMap);
        resolve(this.store.state.genderEnumMap);
      });
    } else {
      return this.GetCall("/api/enum/gender")
        .then((response) => {
          var map = response.data;
          this.store.commit("setGenderEnumMap", {
            genderEnumMap: map
          });
          return new Promise((resolve, reject) => {
            console.log(map);
            resolve(map);
          });
        })
        .catch((e) => {
          console.log(e);
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  GetCitizentypeEnum(force = false) {
    console.log("GetCitizentypeEnum");
    if (this.store.state.citizentypeEnumMap && this.store.state.citizentypeEnumMapState && this.store.state.citizentypeEnumMapState.companyId == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        console.log(this.store.state.citizentypeEnumMap);
        resolve(this.store.state.citizentypeEnumMap);
      });
    } else {
      return this.GetCall("/api/enum/citizentype")
        .then((response) => {
          var map = response.data;
          this.store.commit("setCitizentypeEnumMap", {
            citizentypeEnumMap: map
          });
          return new Promise((resolve, reject) => {
            console.log(map);
            resolve(map);
          });
        })
        .catch((e) => {
          console.log(e);
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  GetCivilstatusEnum(force = false) {
    console.log("GetCivilstatusEnum");
    if (this.store.state.civilstatusEnumMap && this.store.state.civilstatusEnumMapState && this.store.state.civilstatusEnumMapState.companyId == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        console.log(this.store.state.civilstatusEnumMap);
        resolve(this.store.state.civilstatusEnumMap);
      });
    } else {
      return this.GetCall("/api/enum/civilstatus")
        .then((response) => {
          var map = response.data;
          this.store.commit("setCivilstatusEnumMap", {
            civilstatusEnumMap: map
          });
          return new Promise((resolve, reject) => {
            console.log(map);
            resolve(map);
          });
        })
        .catch((e) => {
          console.log(e);
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  getUserDataFromJWT(token) {
    if (token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    }
  }

  logDebug(info, obj = null) {
    this.log(null, info, obj, false);
  }

  truncate(str, n) {
    return str.length > n ? str.substr(0, n - 1) + "..." : str;
  }

  isSafari() {
    var browserInfo = this.getBrowserInfo();
    return browserInfo[0] == "Safari";
  }

  getBrowserInfo() {
    var nAgt = navigator.userAgent;
    var nameOffset, verOffset, ix;
    var browserName = "";
    var mobile = false;

    if ((verOffset = nAgt.indexOf("Opera")) != -1) {
      browserName = "Opera";
    } else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
      browserName = "Microsoft Internet Explorer";
    } else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
      browserName = "Chrome";
    } else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
      browserName = "Safari";
    } else if ((verOffset = nAgt.indexOf("iPhone")) != -1) {
      browserName = "Safari";
    } else if ((verOffset = nAgt.indexOf("iOS")) != -1) {
      browserName = "Safari";
    } else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
      browserName = "Firefox";
    } else if ((nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/"))) {
      browserName = nAgt.substring(nameOffset, verOffset);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    if (nAgt.indexOf("iPhone") != -1 || nAgt.indexOf("iOS") != -1 || nAgt.indexOf("Android") != -1) {
      mobile = true;
    }
    return [browserName, mobile];
  }

  appendParam(name, param, url, baseUrl) {
    if (!this.isBlank(param)) {
      if (url == baseUrl && url.indexOf("?") == -1) {
        url += "?" + name + "=" + param;
      } else {
        url += "&" + name + "=" + param;
      }
    }
    return url;
  }

  loadTimeZone(zone) {}

  isEmpty(val) {
    if (val == undefined || val === "") return true;
    return false;
  }

  isBlank(str) {
    if (typeof str === "boolean" || this.isInt(str)) {
      return false;
    } else {
      return !str || /^\s*$/.test(str);
    }
  }

  isInt(value) {
    var x;
    if (isNaN(value)) {
      return false;
    }
    x = parseFloat(value);
    return (x | 0) === x;
  }

  roundNumber(number, decimals) {
    var mult = Math.pow(10, decimals);
    return Math.round(number * mult) / mult;
  }

  round2(number) {
    return this.roundNumber(number, 2);
  }

  euroInputToCents(input) {
    var inputFloat = input;

    if (typeof input === "string") {
      // fix decimal char and parse float value
      input = input.replace(",", ".");
      inputFloat = parseFloat(input);
    }

    var cents = Math.round(inputFloat * 100);
    return cents;
  }

  formatPayment(centValue) {
    if (centValue != null) {
      var euro = centValue / 100;
      var frmtEuro = euro.toFixed(2);
      frmtEuro = frmtEuro.replace(".", ",");
      return "€ " + frmtEuro;
    }
    return "";
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
      type: mime
    });
  }

  timeout(title, message) {
    return title.length * 60 + message.length * 60;
  }

  success(title, message) {
    window.app.popupmessages.push({
      startTime: new Date().getTime(),
      timer: this.timeout(title, message),
      type: "success",
      header: title,
      description: message
    });
  }

  OpenPopup(state) {
    if (state && state.draggable && this.DragOpenedCheck()) return; //if you're already dragging a popup don't open it, it's better to put this here then on every mousedown function
    state.created = new Date().getTime();
    window.app.genericPopups.push(state);
    return state;
  }

  CheckDatafillKeysForHiddenInverted(...entryKeys) {
    if (!entryKeys.find) {
      let temp = [];
      temp.push(entryKeys);
      entryKeys = temp;
    }
    return (entries, entry) => {
      let value = false;
      if (!entries) {
        return value;
      }
      if (!entries.length) {
        entries = Object.values(entries);
      }
      if (entries.length) {
        value = !entryKeys.every((k) => entries.find((e) => e.key === k && !e.value));
      }
      return value;
    };
  }

  CheckDatafillKeysForHidden(...entryKeys) {
    if (!entryKeys.find) {
      let temp = [];
      temp.push(entryKeys);
      entryKeys = temp;
    }
    return (entries, entry) => {
      let value = false;
      if (!entries) {
        return value;
      }
      if (!entries.length) {
        entries = Object.values(entries);
      }
      if (entries.length) {
        value = entryKeys.every((k) => entries.find((e) => e.key === k && !e.value));
      }
      return value;
    };
  }

  documentTypes() {
    // should be in a database (enum_documents --> not sure if used anywhere outside of ML)
    let types = [
      {
        value: "CONTRACT",
        label_en: "Contract",
        label: 'employee.contract.contractHeader',
      },
      {
        value: "DRIVERSLICENSE",
        label_en: "Drivers License",
        label: 'employee.core.driversLicense',
      },
      {
        value: "REGISTRATION",
        label_en: "Registration",
        label: 'comp.help.registration',
      },
      {
        value: "ID",
        label_en: "Id",
        label: 'comp.help.id',
      },
      {
        value: "EXPORT",
        label_en: "Export",
        label: 'comp.help.export',
      },
      {
        value: "ACCOUNTINGREGISTRATION",
        label_en: "Accounting Registration",
        label: 'comp.help.accountingRegistration',
      },
      {
        value: "ACCOUNTINGDEREGISTRATION",
        label_en: "Accounting Deregistration",
        label: 'comp.help.accountingDeregistration',
      },
      {
        value: "PAYSLIP",
        label_en: "Payslip",
        label: 'comp.help.payslip',
      },
      {
        value: "WORKPERMIT",
        label_en: "Work Permit",
        label: 'comp.help.workPermit',
      },
      {
        value: "RESIDENCEPERMIT",
        label_en: "Residence Permit",
        label: 'comp.help.residencePermit',
      },
      {
        value: "RESIDENCEWORKPERMIT",
        label_en: "Residence & Work Permit",
        label: 'comp.help.residenceWorkPermit',
      },
      {
        value: "EDUCATIONCERTIFICATE",
        label_en: "Education Certificate",
        label: 'comp.help.educationCertificate',
      },
      {
        value: "ASYLUMPASS",
        label_en: "Passport for Asylum Seekers",
        label: 'comp.help.asylumPass',
      },
      {
        value: "ALIENPASS",
        label_en: "Alien's passport",
        label: 'comp.help.alienPass',
      },
      {
        value: "HEALTHRULES",
        label_en: "Health Rules",
        label: 'comp.help.healthRules',
      },
      {
        value: "UNIFORMFORM",
        label_en: "Uniform Form",
        label: 'comp.help.uniformForm',
      },
      {
        value: "NOTE",
        label_en: "Note",
        label: 'comp.help.note',
      },
      {
        value: "NOTICEOFPREGNANCY",
        label_en: "Notice of Pregnancy",
        label: 'comp.help.noticeOfPregnancy',
      },
      {
        value: "NOTICEOFSICKNESS",
        label_en: "Notice of Sickness",
        label: 'comp.help.noticeOfSickness',
      },
      {
        value: "ACCIDENTPREVENTION",
        label_en: "Accident Prevention",
        label: 'comp.help.accidentPrevention',
      },
      {
        value: "OPERATINGRULES",
        label_en: "Operating Rules",
        label: 'comp.help.operatingRules',
      },
      {
        value: "PASSPORT",
        label_en: "Passport",
        label: 'comp.help.passport',
      },
      {
        value: "BANKACCOUNTINFO",
        label_en: "Bank Account Info",
        label: 'employee.core.bankAccount',
      },
      {
        value: "SOCIALSECURITYCARD",
        label_en: "Social Security Card",
        label: 'comp.help.socialSecurityCard',
      },
      {
        value: "OFFICIALNOTICE",
        label_en: "Official Notice",
        label: 'comp.help.officialNotice',
      },
      {
        value: "NOTICEOFRESIGNATION",
        label_en: "Notice of Resignation",
        label: 'comp.help.noticeOfResignation',
      },
      {
        value: "NOTICEOFCHANGE",
        label_en: "Notice of Change",
        label: 'comp.help.noticeOfChange',
      },
      {
        value: "SOCIALSECURITYREGISTRATION",
        label_en: "Social Security Registration",
        label: 'comp.help.socialSecurityRegistration',
      },
      {
        value: "SOCIALSECURITYDEREGISTRATION",
        label_en: "Social Security Deregistration",
        label: 'comp.help.socialSecurityDeregistration',
      },
      {
        value: "VACCINATIONCERTIFICATE",
        label_en: "Vaccination Certificate",
        label: 'comp.help.vaccinationCertificate',
      },
      {
        value: "CUSTOMCERTIFICATE",
        label_en: "Custom Certificate",
        label: 'comp.help.customCertificate',
      },
      {
        value: "VACATIONREQUEST",
        label_en: "Vacation Request",
        label: 'comp.help.vacationRequest',
      },
      {
        value: "CONSENTFORM",
        label_en: "Consent Form",
        label: 'comp.help.consentForm',
      },
      {
        value: "WORKTIMEPROTOCOL",
        label_en: "Worktime Protocol",
        label: 'comp.help.worktimeProtocol',
      },
      {
        value: "PARENTALLEAVEAGREEMENT",
        label_en: "Parental Leave Agreement",
        label: 'comp.help.parentalLeaveAgreement',
      },
      {
        value: "EVLAUATION",
        label_en: "Evaluation",
        label: 'comp.help.evaluation',
      },
      {
        value: "REPRIMAND",
        label_en: "Reprimand",
        label: 'comp.help.reprimand',
      },
      {
        value: "REPAYMENT",
        label_en: "Repayment",
        label: 'comp.help.repayment',
      },
      {
        value: "APPLICATIONDOC",
        label_en: "Application Document",
        label: 'comp.help.applicationDoc',
      },
      {
        value: "INSTRUCTION",
        label_en: "Instruction",
        label: 'comp.help.instruction',
      },
      {
        value: "PUBLICTRANSPORT",
        label_en: "Public Transport Ticket",
        label: 'comp.help.publicTransportTicket',
      },
      {
        value: "PRIORSERVICECONFIRMATION",
        label_en: "Prior Service Confirmation",
        label: 'comp.help.priorServiceConfirmation',
      },
      {
        value: "ADDAGREEMENT",
        label_en: "Additional Agreement",
        label: 'comp.help.additionalAgreement',
      }
    ];
    types.sort((a, b) => this.i18n.t(a.label).localeCompare(this.i18n.t(b.label)));
    types.push({
      value: "MISC",
      label_en: "Miscellaneous",
      label: 'comp.help.misc',
    });
    return types;
  }

  documentTypeLabel(type) {
    let label = "";
    this.documentTypes().forEach((t) => {
      if (t.value == type) label = t.label;
    });
    return label;
  }

  documentMimeIcons() {
    let types = [
      {
        value: "application/pdf",
        label: "file-pdf"
      },
      {
        value: "NOTICEOFPREGNANCY",
        label: "file-image"
      },
      {
        value: "text/csv",
        label: "file-csv"
      }
    ];
    return types;
  }
  documentMimeIcon(type) {
    let label = "file";
    this.documentMimeIcons().forEach((t) => {
      if (t.value == type) label = t.label;
    });
    return label;
  }

  GetExportDeselectedStores() {
    let ls = localStorage.getItem("export_deselected_stores");
    let deselectedStores = {};
    if (ls != undefined) {
      deselectedStores = JSON.parse(ls);
    }
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(deselectedStores, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportDeselectedStores(data) {
    localStorage.setItem("export_deselected_stores", JSON.stringify(data));
  }

  GetExportSelectedWagetypesMonthly() {
    let ls = localStorage.getItem("export_selected_wagetypes_monthly");
    let wagetypes = {};
    if (ls != undefined) {
      wagetypes = JSON.parse(ls);
    }
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(wagetypes, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportSelectedWagetypesMonthly(data) {
    localStorage.setItem("export_selected_wagetypes_monthly", JSON.stringify(data));
  }

  GetExportSelectedWagetypesIndividualWagetypes() {
    let ls = localStorage.getItem("export_selected_wagetypes_individual-wagetypes_" + this.store.state.companyId);
    let wagetypes = {};
    if (ls != undefined) {
      wagetypes = JSON.parse(ls);
    }
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(wagetypes, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportSelectedWagetypesIndividualWagetypes(data) {
    localStorage.setItem("export_selected_wagetypes_individual-wagetypes_" + this.store.state.companyId, JSON.stringify(data));
  }

  GetExportSelectedEmploymentModelsIndividualWagetypes() {
    let ls = localStorage.getItem("export_selected_models_individual-wagetypes_" + this.store.state.companyId);
    let models = {};
    if (ls != undefined) {
      models = JSON.parse(ls);
    }
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(models, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportSelectedEmploymentModelsIndividualWagetypes(data) {
    localStorage.setItem("export_selected_models_individual-wagetypes_" + this.store.state.companyId, JSON.stringify(data));
  }

  GetExportSelectedEmploymentModelsSlovenianParttimeExport() {
    let ls = localStorage.getItem("export_selected_models_slovenian-parttime_" + this.store.state.companyId);
    let models = {};
    if (ls != undefined) {
      models = JSON.parse(ls);
    }
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(models, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportSelectedEmploymentModelsSlovenianParttimeExport(data) {
    localStorage.setItem("export_selected_models_slovenian-parttime_" + this.store.state.companyId, JSON.stringify(data));
  }

  GetExportSelectedEmploymentModelsSlovenianPensionersExport() {
    let ls = localStorage.getItem("export_selected_models_slovenian-pensioners_" + this.store.state.companyId);
    let models = {};
    if (ls != undefined) {
      models = JSON.parse(ls);
    }
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(models, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportSelectedEmploymentModelsSlovenianPensionersExport(data) {
    localStorage.setItem("export_selected_models_slovenian-pensioners_" + this.store.state.companyId, JSON.stringify(data));
  }
  GetExportSelectedCollectiveContractSlovenianPensionersExport() {
    const selectedId = localStorage.getItem("export_selected_collective_contract_slovenian-pensioners_" + this.store.state.companyId);
    return Promise.resolve(JSON.parse(selectedId));
  }
  SetExportSelectedCollectiveContractSlovenianPensionersExport(id) {
    localStorage.setItem("export_selected_collective_contract_slovenian-pensioners_" + this.store.state.companyId, JSON.stringify(id));
  }

  GetExportSelectedCollectiveContractsSlovenianExport(mode) {
    const selectedIds = localStorage.getItem("export_selected_collective_contracts_slovenian-" + mode + "_" + this.store.state.companyId);
    if (selectedIds !== null) {
      const ids = JSON.parse(selectedIds);
      return Promise.resolve(Array.isArray(ids) ? ids : []);
    }
    if (mode === "pensioner") {
      return this.GetExportSelectedCollectiveContractSlovenianPensionersExport().then(id => id === null ? [] : [id]);
    }
    return Promise.resolve([]);
  }
  SetExportSelectedCollectiveContractsSlovenianExport(mode, ids) {
    localStorage.setItem("export_selected_collective_contracts_slovenian-" + mode + "_" + this.store.state.companyId, JSON.stringify(ids));
  }

  GetExportSelectedWagetypesDaily() {
    let ls = localStorage.getItem("export_selected_wagetypes_daily");
    let wagetypes = {};
    if (ls != undefined) {
      wagetypes = JSON.parse(ls);
    }
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(wagetypes, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportSelectedWagetypesDaily(data) {
    localStorage.setItem("export_selected_wagetypes_daily", JSON.stringify(data));
  }

  GetExportSelectedColumns(mode) {
    let ls = localStorage.getItem("export_selected_columnsettings_" + mode + "_" + this.store.state.companyId);
    let columnSettings = {};
    if (ls != undefined) {
      columnSettings = JSON.parse(ls);
    } else {
      // fall back to old version
      ls = localStorage.getItem("export_selected_columnsettings_" + mode);
      if (ls != undefined) {
        columnSettings = JSON.parse(ls);
      }
    }
    // console.log("GetExportSelectedColumns", columnSettings);
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(columnSettings, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportSelectedColumns(data, mode) {
    // console.log("SetExportSelectedColumns", data);
    localStorage.setItem("export_selected_columnsettings_" + mode + "_" + this.store.state.companyId, JSON.stringify(data));
  }

  GetExportSelectedDate() {
    let ls = localStorage.getItem("export_selected_date");
    let selectedDate = {};
    if (ls != undefined) {
      selectedDate = JSON.parse(ls);
    }
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(selectedDate, false));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  SetExportSelectedDate(data) {
    localStorage.setItem("export_selected_date", JSON.stringify(data));
  }

  warning(title, message) {
    window.app.popupmessages.push({
      startTime: new Date().getTime(),
      timer: this.timeout(title, message),
      type: "warning",
      header: title,
      description: message
    });
  }

  error(title, message) {
    window.app.popupmessages.push({
      startTime: new Date().getTime(),
      timer: this.timeout(title, message),
      type: "error",
      header: title,
      description: message
    });
  }

  info(title, message) {
    window.app.popupmessages.push({
      startTime: new Date().getTime(),
      timer: this.timeout(title, message),
      type: "info",
      header: title,
      description: message
    });
  }

  formatDateStringTZ(datestr, format = null) {
    if (format != null) {
      if (this.store.state.companySettings.timeZone) {
        if (!this.isBlank(datestr)) {
          return moment.tz(datestr, this.store.state.companySettings.timeZone).locale(this.locale).format(format);
        } else {
          return moment(datestr).format(format).locale(this.locale);
        }
      }
    }
    return this.convertDateStringTZ(datestr);
  }

  convertDateString(datestr) {
    if (!this.isBlank(datestr)) {
      return moment(datestr).format("YYYY-MM-DDTHH:mmZ");
    } else {
      return null;
    }
  }

  convertDateStringUTC(datestr) {
    if (!this.isBlank(datestr)) {
      return moment.utc(datestr).format("YYYY-MM-DDTHH:mmZ");
    } else {
      return null;
    }
  }

  convertUTCDateStringTZ(datestr, format = "YYYY-MM-DDTHH:mmZ") {
    if (!this.isBlank(datestr) && this.store.state.companySettings.timeZone) {
      let mom = moment.utc(datestr);
      return moment(mom).tz(this.store.state.companySettings.timeZone).format(format);
    } else {
      let mom = moment.utc(datestr);
      return moment(mom).tz("Europe/Vienna").format(format);
    }
  }

  convertDateStringTZ(datestr) {
    if (this.store.state.companySettings.timeZone) {
      if (!this.isBlank(datestr)) {
        return moment.tz(datestr, this.store.state.companySettings.timeZone).format("YYYY-MM-DDTHH:mmZ");
      } else {
        return null;
      }
    }
    return this.convertDateString(datestr);
  }

  convertDateTimeString(datestr, timestr) {
    if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
      return moment(datestr + "T" + timestr).format("YYYY-MM-DDTHH:mmZ");
    } else if (!this.isBlank(datestr)) {
      return moment(datestr + "T00:00:00").format("YYYY-MM-DDTHH:mmZ");
    } else if (!this.isBlank(timestr)) {
      return moment(timestr, "HH:mm").format("HH:mmZ");
    } else {
      return null;
    }
  }

  convertDateTimeStringUTC(datestr, timestr) {
    if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
      return moment.utc(datestr + "T" + timestr).format("YYYY-MM-DDTHH:mmZ");
    } else if (!this.isBlank(datestr)) {
      return moment.utc(datestr + "T00:00:00").format("YYYY-MM-DDTHH:mmZ");
    } else if (!this.isBlank(timestr)) {
      return moment.utc(timestr, "HH:mm").format("HH:mmZ");
    } else {
      return null;
    }
  }

  convertDateTimeStringTZ(datestr, timestr) {
    if (this.store.state.companySettings.timeZone) {
      if (!this.isBlank(datestr) && !this.isBlank(timestr)) {
        return moment.tz(datestr + "T" + timestr, this.store.state.companySettings.timeZone).format("YYYY-MM-DDTHH:mmZ");
      } else if (!this.isBlank(datestr)) {
        return moment.tz(datestr + "T00:00:00", this.store.state.companySettings.timeZone).format("YYYY-MM-DDTHH:mmZ");
      } else if (!this.isBlank(timestr)) {
        return moment.tz("2019-11-01T" + timestr, this.store.state.companySettings.timeZone).format("HH:mmZ");
      } else {
        return null;
      }
    }
    return this.convertDateTimeString(datestr, timestr);
  }

  extractDateStringTZ(datestr, format = "YYYY-MM-DD", midnightIsPreviousDay = false) {
    if (this.store.state.companySettings.timeZone) {
      if (!this.isBlank(datestr)) {
        if (midnightIsPreviousDay) {
          return moment.tz(datestr, this.store.state.companySettings.timeZone).add(-1, "minute").format(format);
        }
        return moment.tz(datestr, this.store.state.companySettings.timeZone).format(format);
      } else {
        return null;
      }
    }
    return this.extractDateStringDefaultTZ(datestr, format);
  }

  extractTimeStringTZ(str, format = "HH:mm") {
    if (this.store.state.companySettings.timeZone) {
      if (!this.isBlank(str)) {
        return moment.tz(str, "HH:mmZ", this.store.state.companySettings.timeZone).format(format);
      } else {
        return null;
      }
    }
    return this.extractTimeString(datestr, format);
  }

  extractDateString(datestr, format = "YYYY-MM-DD") {
    if (!this.isBlank(datestr)) {
      return moment.utc(datestr).format(format);
    } else {
      return null;
    }
  }

  extractDateStringDefaultTZ(datestr, format = "YYYY-MM-DD") {
    if (!this.isBlank(datestr)) {
      return moment.utc(datestr).tz("Europe/Vienna").format(format);
    } else {
      return null;
    }
  }

  extractTimeString(str, format = "HH:mm") {
    if (!this.isBlank(str)) {
      return moment.utc(str, "HH:mmZ").format(format);
    } else {
      return null;
    }
  }

  getNowDateTimeString(format = "DD.MM.YYYY HH:mm") {
    return this.getMomentTZ().format(format);
  }

  getWeekDays() {
    return moment.weekdays();
  }

  getActualMoment(param = null) {
    if (param) {
      return moment(param).locale(this.locale);
    }
    return moment;
  }

  getMoment() {
    return moment().locale(this.locale);
  }

  getMomentUTC() {
    return moment.utc().locale(this.locale);
  }

  getMomentTZ() {
    if (this.store.state.companySettings.timeZone) {
      //console.log("timezone");
      return moment.tz(this.store.state.companySettings.timeZone).locale(this.locale);
    }
    return this.getMoment();
  }

  getMomentTZStartOfDay() {
    return this.getMomentTZ().hours(0).minutes(0).seconds(0).milliseconds(0);
  }

  getMomentFromString(str, format = "YYYY-MM-DDTHH:mmZ") {
    return moment(str, format).locale(this.locale);
  }

  getMomentFromStringUTC(str, format = "YYYY-MM-DDTHH:mmZ") {
    return moment.utc(str, format).locale(this.locale);
  }

  getMomentFromStringTZ(str, format = "YYYY-MM-DDTHH:mmZ") {
    if (this.store.state.companySettings.timeZone) {
      return moment.tz(str, format, this.store.state.companySettings.timeZone).locale(this.locale);
    }
    return this.getMomentFromString(str, format);
  }

  getNextMonthMoment() {
    return moment().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, "M").locale(this.locale);
  }

  getNextMonthMomentUTC() {
    return moment.utc().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, "M").locale(this.locale);
  }

  getNextMonthMomentTZ() {
    if (this.store.state.companySettings.timeZone) {
      return moment.tz(this.store.state.companySettings.timeZone).date(1).hours(0).minutes(0).seconds(0).milliseconds(0).add(1, "M").locale(this.locale);
    }
    return this.getNextMonthMoment();
  }

  getCurrentMoment() {
    return moment().locale(this.locale);
  }

  getCurrentMonthMoment() {
    return moment().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale(this.locale);
  }

  getCurrentMonthMomentUTC() {
    return moment.utc().date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale(this.locale);
  }

  getCurrentMonthMomentTZ() {
    if (this.store.state.companySettings.timeZone) {
      return moment.tz(this.store.state.companySettings.timeZone).date(1).hours(0).minutes(0).seconds(0).milliseconds(0).locale(this.locale);
    }
    return this.getCurrentMonthMoment();
  }

  getMomentFromUnix(unix = 0) {
    return moment.unix(unix).locale(this.locale);
  }

  getMomentFromUnixUTC(unix = 0) {
    return moment.utc().unix(unix).locale(this.locale);
  }

  getMomentFromValues(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    return moment().year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale(this.locale);
  }

  getMomentFromValuesUTC(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    return moment.utc().year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale(this.locale);
  }

  getMomentFromValuesTZ(year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    if (this.store.state.companySettings.timeZone) {
      return moment.tz(this.store.state.companySettings.timeZone).year(year).month(month).date(day).hours(hours).minutes(minutes).seconds(seconds).milliseconds(milliseconds).locale(this.locale);
    }
    return this.getMomentFromValues(year, month, day, hours, minutes, seconds, milliseconds);
  }

  getMomentDuration(start, end) {
    return moment.duration(end.diff(start)).locale(this.locale);
  }

  gender(code) {
    switch (code) {
      case "M":
        return this.i18n.t('employee.insure.male');
      case "F":
        return this.i18n.t('employee.insure.female');
      default:
        return "";
    }
  }

  salutation(code) {
    switch (code) {
      case "M":
        return this.i18n.t('comp.help.salutationMale');
      case "F":
        return this.i18n.t('comp.help.salutationFemale');
      default:
        return "";
    }
  }

  monthName(month) {
    switch (month) {
      case 0:
        return this.i18n.t('global.time.month0');
      case 1:
        return this.i18n.t('global.time.month1');
      case 2:
        return this.i18n.t('global.time.month2');
      case 3:
        return this.i18n.t('global.time.month3');
      case 4:
        return this.i18n.t('global.time.month4');
      case 5:
        return this.i18n.t('global.time.month5');
      case 6:
        return this.i18n.t('global.time.month6');
      case 7:
        return this.i18n.t('global.time.month7');
      case 8:
        return this.i18n.t('global.time.month8');
      case 9:
        return this.i18n.t('global.time.month9');
      case 10:
        return this.i18n.t('global.time.month10');
      case 11:
        return this.i18n.t('global.time.month11');
      default:
        return "";
    }
  }

  getRandomLightColor() {
    let color = this.hslToHex(Math.random() * 360, 100, 75);
    return color;
  }

  hslToHex(h, s, l) {
    h /= 360;
    s /= 100;
    l /= 100;
    let r, g, b;
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    const toHex = (x) => {
      const hex = Math.round(x * 255).toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  hexToHSLObject(H) {
    let r = 0,
      g = 0,
      b = 0;
    if (H.length === 4) {
      r = "0x" + H[1] + H[1];
      g = "0x" + H[2] + H[2];
      b = "0x" + H[3] + H[3];
    } else if (H.length === 7) {
      r = "0x" + H[1] + H[2];
      g = "0x" + H[3] + H[4];
      b = "0x" + H[5] + H[6];
    }
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b),
      cmax = Math.max(r, g, b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;

    if (delta === 0) h = 0;
    else if (cmax === r) h = ((g - b) / delta) % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0) h += 360;

    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    return {
      h: h,
      s: s,
      l: l
    };
  }

  hexToRGBObject(H) {
    let r = 0,
      g = 0,
      b = 0;
    if (H.length === 4) {
      r = "0x" + H[1] + H[1];
      g = "0x" + H[2] + H[2];
      b = "0x" + H[3] + H[3];
    } else if (H.length === 7) {
      r = "0x" + H[1] + H[2];
      g = "0x" + H[3] + H[4];
      b = "0x" + H[5] + H[6];
    }
    r /= 1;
    g /= 1;
    b /= 1;

    return {
      r: r,
      g: g,
      b: b
    };
  }

  hexToHSL(H) {
    let hsl = this.hexToHSLObject(H);
    return "hsl(" + hsl.h + "," + hsl.s + "%," + hsl.l + "%)";
  }

  PopupNewEvent($event, date, copyEvents, createCallback) {
    var view = this;
    let copyEventItems = [];
    copyEventItems.push({
      label: this.i18n.t('report.comp.standard'),
      name: this.i18n.t('report.comp.standard'),
      value: null
    });
    copyEvents.forEach((e) => {
      if (e.name == null) {
        e.name = e.label;
      }
      copyEventItems.push(e);
    });
    let from = date.clone().hours(0);

    let to = date.clone().hours(0).add(1, "days");

    let nameEntry = {
      label: this.i18n.t('settings.groups.name'),
      key: "name",
      hidden: false,
      type: "text",
      value: "Event",
      length: 20
    };
    let dataEntries = [
      {
        label: this.i18n.t('report.comp.from'),
        key: "from",
        hidden: false,
        type: "timeframe",
        value: from,
        flexGroup: true,
        timeBig: true,
        startTime: true
      },
      {
        label: this.i18n.t('report.comp.to'),
        key: "to",
        hidden: false,
        type: "timeframe",
        value: to,
        flexGroup: true,
        timeBig: true,
        endTime: true
      },
      {
        divider: true
      },
      nameEntry,
      {
        label: this.i18n.t('comp.help.occupancy'),
        key: "copyEventId",
        hidden: false,
        type: "dropdownsearch",
        value: null,
        selectMultiple: false,
        flexGroup: true,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: copyEventItems,
          selectMultiple: false,
          selectFirst: true,
          selectedItems: [],
          selectedItem: null,
          onceSelected: function ($event, item, searchbar) {
            if (view.isEmpty(nameEntry.value)) {
              nameEntry.value = item.name;
            }
          },
          styleLight: true
        },
        styles: {
          width: "342px"
        }
      },
      {
        label: this.i18n.t('settings.groups.color'),
        key: "color",
        hidden: false,
        type: "color",
        value: view.getRandomLightColor()
      },
      {
        label: this.i18n.t('comp.help.fromDay'),
        key: "fromDate",
        hidden: false,
        type: "date",
        value: from.clone(),
        flexGroup: true,
        styles: {
          "margin-right": "10px"
        }
      },
      {
        label: this.i18n.t('comp.help.toDay'),
        key: "toDate",
        hidden: false,
        type: "date",
        value: to.clone(),
        flexGroup: true
      },
      {
        flexDivider: true
      },
      {
        label: this.i18n.t('comp.help.federalHoliday'),
        key: "federalHoliday",
        hidden: false,
        type: "bool",
        value: false,
        flexGroup: true
      },
      {
        label: this.i18n.t('comp.help.bankHoliday'),
        key: "bankHoliday",
        hidden: false,
        type: "bool",
        value: false,
        flexGroup: true
      },
      {
        flexDivider: true
      },
      {
        label: this.i18n.t('comp.help.createWithTemplates'),
        key: "createWithTemplates",
        hidden: false,
        type: "bool",
        value: true,
        flexGroup: true
      },
      {
        label: this.i18n.t('settings.centers.desc'),
        key: "description",
        hidden: false,
        type: "text",
        value: "",
        length: 20
      },
      {
        label: this.i18n.t('comp.help.shiftMode'),
        key: "shiftCreationMode",
        hidden: false,
        type: "dropdownsearch",
        value: 0,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: [
            {
              label: this.i18n.t('comp.help.shiftOccupancyReplacement'),
              value: 0
            },
            {
              label: this.i18n.t('comp.help.shiftOccupancyAddition'),
              value: 1
            },
            {
              label: this.i18n.t('comp.help.noShifts'),
              value: 2
            }
          ],
          selectMultiple: false,
          selectFirst: true,
          selectedItems: [],
          styleLight: true
        }
      }
    ];
    let target = $event.currentTarget;

    this.OpenPopup({
      elRelative: target,
      type: "datafill",
      componentState: {
        entries: dataEntries,
        selectCallback: createCallback
      },
      header: this.i18n.t('comp.help.newEvent'),
      expanded: true,
      centered: true
    });
  }

  PopupEditEvent($event, event, editCallback) {
    let view = this;
    let from = event.fromMoment.clone();

    let to = event.toMoment.clone();

    let dataEntries = [
      {
        label: this.i18n.t('comp.help.id'),
        key: "id",
        hidden: true,
        type: "text",
        value: event.id,
        length: 20
      },
      {
        label: this.i18n.t('settings.groups.name'),
        key: "name",
        hidden: false,
        type: "text",
        value: "",
        length: 20
      },
      {
        label: this.i18n.t('settings.groups.color'),
        key: "color",
        hidden: false,
        type: "color",
        value: event.color
      },
      {
        label: this.i18n.t('comp.help.fromDay'),
        key: "fromDate",
        hidden: false,
        type: "date",
        value: from.clone()
      },
      {
        label: this.i18n.t('comp.help.from'),
        key: "from",
        hidden: false,
        type: "timeframe",
        value: from
      },
      {
        label: this.i18n.t('comp.help.toDay'),
        key: "toDate",
        hidden: false,
        type: "date",
        value: to.clone()
      },
      {
        label: this.i18n.t('comp.help.to'),
        key: "to",
        hidden: false,
        type: "timeframe",
        value: to
      },
      {
        label: this.i18n.t('comp.help.federalHoliday'),
        key: "federalHoliday",
        hidden: false,
        type: "bool",
        value: event.federalHoliday
      },
      {
        label: this.i18n.t('comp.help.bankHoliday'),
        key: "bankHoliday",
        hidden: false,
        type: "bool",
        value: event.bankHoliday
      },
      {
        label: this.i18n.t('settings.centers.desc'),
        key: "description",
        hidden: false,
        type: "text",
        value: event.description,
        length: 20
      },
      {
        label: this.i18n.t('comp.help.shiftMode'),
        key: "shiftCreationMode",
        hidden: false,
        type: "dropdownsearch",
        value: event.shiftCreationMode,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: [
            {
              label: this.i18n.t('comp.help.shiftOccupancyReplacement'),
              value: 0
            },
            {
              label: this.i18n.t('comp.help.shiftOccupancyAddition'),
              value: 1
            },
            {
              label: this.i18n.t('comp.help.noShifts'),
              value: 2
            }
          ],
          selectMultiple: false,
          selectFirst: false,
          selectedItems: [],
          styleLight: true
        }
      }
    ];

    if (event) {
      for (let x in event) {
        let entry = dataEntries.find((e) => e.key === x);
        if (entry) {
          if (x === "from" || x === "to") {
            //do nothing cause datafill a shit
          } else if (x === "shiftCreationMode") {
            entry.dropdownSearchState.selectedItem = entry.dropdownSearchState.items.find((i) => event[x] === i.value);
            if (entry.dropdownSearchState.selectedItem) entry.dropdownSearchState.input = entry.dropdownSearchState.selectedItem.label;
          } else {
            entry.value = event[x];
          }
        }
      }
    }
    let target = $event.currentTarget;

    this.OpenPopup({
      elRelative: target,
      type: "datafill",
      componentState: {
        entries: dataEntries,
        selectCallback: editCallback
      },
      header: this.i18n.t('comp.help.editEvent'),
      expanded: true,
      centered: true
    });
  }

  TimeDiff(a, b) {
    if (!a || !b || !a.format || !b.format) return NaN;
    return b._d.getTime() - a._d.getTime();
  }

  OpenAlert(state) {
    window.app.popupalerts.push({
      header: state.header,
      description: state.description,
      callbackAccept: state.callbackAccept,
      callbackCancel: state.callbackCancel,
      disableAccept: state.disableAccept ? state.disableAccept : false,
      disableCancel: state.disableCancel ? state.disableCancel : false,
      enableExternal: state.enableExternal ? state.enableExternal : false,
      externalUrl: state.externalUrl,
      externalLabel: state.externalLabel,
      acceptLabel: state.acceptLabel ? state.acceptLabel : this.i18n.t('employee.data.ok'),
      cancelLabel: state.cancelLabel ? state.cancelLabel : this.i18n.t('settings.ui.cancel')
    });
  }

  OpenDatepicker(state) {
    window.app.datepickerState = state;
  }

  /*
      sumArray should look like this if any
      let dataSum = [];
      let dataSumItem = {};
      let keyStart = Object.keys(headerMap)[0];
      dataSumItem[keyStart] = {key: keyStart, label: 'Total'};
      dataSumItem['amount'] = {key: amount, label: data.map(i => i.amount).reduce((total, current) => { return total + current})};
  */
  GetDataTableStateFromObject(dataItem, dataArray, sumArray) {
    let headerMap = {};

    for (let key in dataItem) {
      headerMap[key] = {
        key: key,
        DisplayLabel: (d) => d[key],
        sort: dataItem.sort ? dataItem.sort : null
      };
    }

    return {
      headerMap: headerMap,
      data: dataArray ? dataArray : [],
      dataSum: sumArray ? sumArray : []
    };
  }

  GetDataTableStateFromKeyLabelObject(dataItem, dataArray, sumArray) {
    let headerMap = {};

    for (let key in dataItem) {
      headerMap[key] = {
        key: key,
        label: dataItem[key] && dataItem !== "" ? dataItem[key] : this.ConvertKeyToName(key),
        DisplayLabel: (d) => d[key],
        sort: dataItem.sort ? dataItem.sort : null
      };
    }

    return {
      headerMap: headerMap,
      data: dataArray ? dataArray.filter((item) => item !== null && !item.hidden) : [],
      dataSum: sumArray ? sumArray : []
    };
  }

  ConvertKeyToName(key) {
    if (key === undefined) return "";
    key = key.toString();
    let label = "";
    let temp = "";
    key
      .split("_")
      .filter((l) => l.length > 0)
      .forEach((l) => (temp += l[0].toUpperCase() + l.substr(1) + " "));
    label = temp;
    temp = "";
    label
      .split("-")
      .filter((l) => l.length > 0)
      .forEach((l) => (temp += l[0].toUpperCase() + l.substr(1) + " "));
    label = temp;
    temp = "";
    label
      .split(/(?=[A-Z])/)
      .filter((l) => l.length > 0)
      .forEach((l) => (temp += " " + l));
    label = temp;
    label = label.replace(/\s\s+/g, " ").trimRight();
    return label;
  }

  GetDataFillStateFromObject(object, selectCallback, asArray = false) {
    let dataEntries = {};
    if (asArray) {
      dataEntries = [];
    }
    for (let x in object) {
      let entry = {
        key: x,
        label: this.ConvertKeyToName(x),
        hidden: false,
        value: object[x],
        type: "text"
      };
      if (asArray) {
        dataEntries.push(entry);
      } else {
        dataEntries[x] = entry;
      }
    }

    return {
      entries: dataEntries,
      selectCallback: selectCallback
    };
  }

  GetDataFillStateFromKeyLabelObject(object, selectCallback) {
    let dataEntries = {};
    for (let x in object) {
      dataEntries[x] = {
        key: x,
        label: object[x],
        hidden: false,
        value: null,
        type: "text"
      };
    }

    return {
      entries: dataEntries,
      selectCallback: selectCallback
    };
  }

  GetCall(url, params) {
    return this.SendCall("get", url, params);
  }

  PostCall(url, payload, params = null) {
    let request = {
      payload: payload,
      params: params
    };
    return this.SendCall("post2", url, request);
  }

  CreateCall(url, object, successCallback, successMessage, errorCallback, errorMessage) {
    if (!successMessage) {
      successMessage = {
        title: this.i18n.t('comp.help.create'),
        message: this.i18n.t('comp.help.createSuccess')
      };
    }
    if (!errorMessage) {
      errorMessage = {
        title: this.i18n.t('comp.help.create'),
        message: this.i18n.t('comp.help.createError')
      };
    }
    return this.SendCall("post", url, object, successCallback, successMessage, errorCallback, errorMessage);
  }

  EditCall(url, object, successCallback, successMessage, errorCallback, errorMessage) {
    if (!successMessage) {
      successMessage = {
        title: this.i18n.t('comp.help.update'),
        message: this.i18n.t('comp.help.updateSuccess')
      };
    }
    if (!errorMessage) {
      errorMessage = {
        title: this.i18n.t('comp.help.update'),
        message: this.i18n.t('comp.help.updateError')
      };
    }
    return this.SendCall("put", url, object, successCallback, successMessage, errorCallback, errorMessage);
  }

  DeleteCall(url, object, successCallback, successMessage, errorCallback, errorMessage) {
    object = {
      id: object.id
    };
    if (!successMessage) {
      successMessage = {
        title: this.i18n.t('settings.notes.delete'),
        message: this.i18n.t('comp.help.deleteSuccess')
      };
    }
    if (!errorMessage) {
      errorMessage = {
        title: this.i18n.t('settings.notes.delete'),
        message: this.i18n.t('comp.help.deleteError')
      };
    }
    return this.SendCall("delete", url, object, successCallback, successMessage, errorCallback, errorMessage);
  }

  SendCall(type, url, object, successCallback, successMessage, errorCallback, errorMessage) {
    let view = this;
    if (type === "put" || type === "post") {
      url = this.appendParam("companyId", this.store.state.companyId, url, url);
      let payload = {
        companyId: this.store.state.companyId
      };
      for (let x in object) {
        if (type === "put" && x !== "id") {
          if (!payload.updateFields) payload.updateFields = [];
          payload.updateFields.push(x);
        }
        payload[x] = object[x];
      }

      return axios({
        method: type,
        headers: {
          AUTHORIZATION: "Bearer " + this.store.state.jwt
        },
        url: url,
        data: payload
      })
        .then((response) => {
          if (successMessage) view.success(successMessage.title, successMessage.message);
          if (successCallback) successCallback(response);
        })
        .catch(function (error) {
          if (errorMessage) view.error(errorMessage.title, errorMessage.message);
          if (errorCallback) errorCallback(error);
        });
    } else if (type === "post2") {
      url = this.appendParam("storeId", this.store.state.storeId, url, url);
      let payload = {
        storeId: this.store.state.storeId
      };

      let params = object.params ? object.params : {};
      for (let x in object.payload) {
        if (type === "put" && x !== "id") {
          if (!payload.updateFields) payload.updateFields = [];
          payload.updateFields.push(x);
        }
        payload[x] = object.payload[x];
      }
      return axios({
        method: "post",
        params: params,
        headers: {
          AUTHORIZATION: "Bearer " + this.store.state.jwt
        },
        url: url,
        data: payload
      });
    } else if (type === "delete") {
      let urlTemp = "";
      urlTemp = this.appendParam("id", object.id, url, url);
      urlTemp = this.appendParam("companyId", this.store.state.companyId, urlTemp, url);
      let axiosData = {
        method: type,
        headers: {
          AUTHORIZATION: "Bearer " + this.store.state.jwt
        },
        url: urlTemp
      };
      return axios(axiosData)
        .then((response) => {
          if (successMessage) view.success(successMessage.title, successMessage.message);
          if (successCallback) successCallback(response);
        })
        .catch(function (error) {
          if (errorMessage) view.error(errorMessage.title, errorMessage.message);
          if (errorCallback) errorCallback(error);
        });
    } else {
      url = this.appendParam("companyId", this.store.state.companyId, url, url);
      let axiosData = {
        method: type,
        headers: {
          AUTHORIZATION: "Bearer " + this.store.state.jwt
        },
        url: url
      };
      if (object) axiosData.params = object;
      return axios(axiosData);
    }
  }

  DateSelectionPopup($event, time, selectCallback, disableDate, disableTime) {
    let view = this;
    let state = this.GetDataFillStateFromObject(
      {
        date: time,
        timeframe: time
      },
      (newTime) => {
        let date = view.getMomentFromStringTZ(newTime.date);
        let timeframe = view.getMomentFromStringTZ(newTime.timeframe);
        let time = date.hours(timeframe.hours).minutes(timeframe.minutes());
        selectCallback(view.convertDateString(time), time);
      }
    );

    state.entries.date.label = "";
    state.entries.date.type = "date";
    state.entries.date.dataStyles = disableTime
      ? {
          "justify-content": "center"
        }
      : {
          "justify-content": "flex-end"
        };
    state.entries.date.styles = {
      "margin-top": "-15px"
    };
    state.entries.date.hidden = disableDate;

    state.entries.timeframe.label = "Time";
    state.entries.timeframe.type = "timeframe";
    state.entries.timeframe.timeBig = true;
    state.entries.timeframe.flexGroup = true;
    state.entries.timeframe.hidden = disableTime;

    state.entries.divider = {
      divider: true,
      styles: {
        opacity: 0,
        margin: 0
      }
    };

    let target = $event.currentTarget;

    this.OpenPopup({
      elRelative: target,
      type: "datafill",
      componentState: state,
      header: "Pick Date Time",
      expanded: true
    });
  }

  returnObj(map, asArray) {
    /* this.log(null, 'returnObj', [map, asArray], false);
    this.log(null, 'returnObj', asArray? Object.values(map) : map, false); */
    return asArray ? (map != null ? Object.values(map) : null) : map;
  }

  idObjectsArrayToMap(responseData) {
    var map = {};
    responseData.forEach((item) => {
      map[item.id] = item;
    });
    return map;
  }

  LoadMaps() {
    let view = this;
    let maps = {};
    view
      .GetCall("/api/employee")
      .then((response) => {
        maps.employeeDataMap = response.data.data;
        window.maps = maps;
      })
      .catch((e) => {
        //view.error('Failed to load maps', e)
      });
  }

  async GetCompanyMap(force = false, asArray = false) {
    if (Object.values(this.store.state.companyMap).length > 0 && !force) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.companyMap, asArray));
      });
    } else {
      let params = {};
      return this.GetCall("/api/list/companies", params)
        .then((response) => {
          let map = response.data;
          this.store.commit("setCompanyMap", {
            companyMap: map
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  async GetCompanyArray(force = false) {
    return this.GetCompanyMap(force, true);
  }

  GetCompanySettings(force = false, asArray = false) {
    // console.log("GetCompanySettings", this.store.state.companySettings.id, this.store.state.companyId);
    if (this.store.state.companySettings && this.store.state.companySettings.id && this.store.state.companySettings.id == this.store.state.companyId && !force) {
      // console.log("GetCompanySettings: from cache");
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.companySettings, asArray));
      });
    } else {
      // console.log("GetCompanySettings: from API");
      let params = {
        companyId: this.store.state.companyId
      };
      return this.GetCall("/api/company", params)
        .then((response) => {
          let map = response.data;

          // console.log("companySettingsMap", map);

          this.store.commit("setCompanySettings", {
            companySettings: map
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }

  GetStoresSettings(force = false, asArray = false) {
    if (this.store.state.storesSettings && this.store.state.storesSettings.data && this.store.state.companySettings.id == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.storesSettings, asArray));
      });
    } else {
      let params = {
        companyId: this.store.state.companyId
      };
      return this.GetCall("/api/stores", params)
        .then((response) => {
          let map = response.data;

          this.store.commit("setStoresSettings", {
            storesSettings: map
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetStoresSettingsArray(force = false) {
    return this.GetStoresSettings(force, true);
  }

  GetStores(force = false, asArray = false) {
    // console.log("GetStores", this.store.state.storeMapState.companyId, this.store.state.companyId);
    if (this.store.state.storeMap && this.store.state.storeMap.length > 0 && this.store.state.storeMapState.companyId === this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.storeMap, asArray));
      });
    } else {
      let params = {
        companyId: this.store.state.companyId
      };
      return this.GetCall("/api/stores", params)
        .then((response) => {
          // TODO: this response is paginated by default but with 2000 elements per page -->
          // unrealistic that a single company receives 2 pages of stores here, anyways it would be cleaner to attempt to load all pages of data
          let map = response.data.data;

          return this.GetMDProxyStores().then((mdStores) => {
            for (let i in mdStores) {
              let mdStore = mdStores[i];
              if (map.find((s) => s.id === mdStore.id) !== undefined) {
                map.find((s) => s.id === mdStore.id).country = mdStore.country;
              }
            }

            this.store.commit("setStoreMap", {
              storeMap: map
            });
            return new Promise((resolve, reject) => {
              resolve(this.returnObj(map, asArray));
            });
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetStoresArray(force = false) {
    return this.GetStores(force, true);
  }

  GetCostCenterMap(force = false, asArray = false) {
    if (this.store.state.costCenterMap && this.store.state.costCenterMapState.companyId === this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.costCenterMap, asArray));
      });
    } else {
      let params = {
        companyId: this.store.state.companyId
      };
      return this.GetCall("/api/costcenters", params)
        .then((response) => {
          // console.log("response GetCostCenterMap", response);
          let map = response.data.data;

          this.store.commit("setCostCenterMap", {
            costCenterMap: map
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetCostCenterArray(force = false) {
    return this.GetCostCenterMap(force, true);
  }
  GetMDProxyStores() {
    return this.GetCall("/api/sec/proxy/md/storeSettings", {})
      .then((response) => {
        return response.data;
      })
      .catch((e) => {
        console.log(e);
      });
  }

  GetSelectedStores(force = false) {
    let selectedLS = localStorage.getItem("selectedStores");
    let stores = undefined;
    if (selectedLS != undefined) {
      let seljson = JSON.parse(selectedLS);
      stores = seljson.stores;
    }
    this.store.commit("setSelectedStores", {
      selectedStores: stores
    });
    return new Promise((resolve, reject) => {
      resolve(this.returnObj(stores, true));
    }).catch((e) => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }

  GetEmployeeMapOLD(force = false, asArray = false, selectedStore) {
    let url = "/api/employee?storeId=" + selectedStore;
    console.log("Fetching employees: " + url);
    return this.GetCall(url)
      .then((response) => {
        let map = {};
        response.data.forEach((employee) => {
          map[employee.id] = employee;
        });
        this.store.commit("setEmployeeMap", {
          employeeMap: map,
          type: "all"
        });
        return new Promise((resolve, reject) => {
          resolve(this.returnObj(map, true));
        });
      })
      .catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
  }

  GetEmployeeMap(force = false, asArray = false) {
    console.log("force " + force);
    if (!force && this.store.state.employeeMap && this.store.state.employeeMapState.companyId === this.store.state.companyId) {
      console.log("Fetching employees from store state");
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.employeeMap, asArray));
      });
    } else {
      let url = "/api/sec/employee/coredata";
      console.log("Fetching employees: " + url);
      return this.GetCall(url)
        .then((response) => {
          let map = response.data.data;
          this.store.commit("setEmployeeMap", {
            employeeMap: map,
            type: "all"
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetEmployeeArray(force = false) {
    return this.GetEmployeeMap(force, true);
  }

  GetActiveEmployeeMap(from, to, force = false, asArray = false) {
    console.log("GET Active EmployeeMap");

    if (!force && this.store.state.employeeActiveMap
        && this.store.state.employeeActiveMapState.companyId === this.store.state.companyId
        && this.store.state.employeeActiveMapState.rosterFromToKey == from + "-" + to) {
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.employeeActiveMap, asArray));
      });
    } else {
      let promises = [];
      promises.push(this.GetEmployeeMap(force, true));
      promises.push(this.GetEmployeeContractMap(force, true));
      return Promise.all(promises)
      .then((results) => {
        let employeeArray = results[0];
        let contractArray = results[1];

        let currentContractArray = contractArray.filter((c) => !(this.getMomentFromStringUTC(c.from).isAfter(to) || (c.to != null && this.getMomentFromStringUTC(c.to).isBefore(from))));
        let activeEmployeeArray = employeeArray.filter((e) => currentContractArray.find((c) => c.remoteId === e.id) != undefined);
        let map = Object.assign({}, activeEmployeeArray);

        this.store.commit("setEmployeeActiveMap", {
          employeeActiveMap: map,
          rosterFromToKey: from + "-" + to
        });
        return new Promise((resolve, reject) => {
          resolve(this.returnObj(map, asArray));
        });
      });
    }
  }
  GetActiveEmployeeArray(force = false) {
    return this.GetActiveEmployeeMap(force, true);
  }

  GetEmployeeContractMap(force = false, asArray = false) {
    if (!force && this.store.state.employeeContractMap && this.store.state.employeeContractMapState.companyId === this.store.state.companyId) {
      // console.log("Fetching employee contracts from store state");
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.employeeContractMap, asArray));
      });
    } else {
      // console.log("Fetching employee contracts from backend");
      let url = "/api/sec/proxy/md/employee/contracts";
      return this.GetCall(url)
        .then((response) => {
          let map = Object.assign({}, response.data)
          this.store.commit("setEmployeeContractMap", {
            employeeContractMap: map
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetEmployeeContractArray(force = false) {
    return this.GetEmployeeContractMap(force, true);
  }

  GetEmployeeSyncExportProfileMap(force = false, asArray = false) {
    if (!force && this.store.state.employeeSyncExportProfileMap && this.store.state.employeeSyncExportProfileMapState.companyId === this.store.state.companyId) {
      // console.log("Fetching employee sync export profiles from store state");
      return new Promise((resolve, reject) => {
        resolve(this.returnObj(this.store.state.employeeSyncExportProfileMap, asArray));
      });
    } else {
      // console.log("Fetching employee sync export profiles from backend");
      let url = "/api/sec/employeesync/exportProfiles";
      return this.GetCall(url)
        .then((response) => {
          let map = Object.assign({}, response.data);
          console.log("GetEmployeeSyncExportProfileMap", map);
          this.store.commit("setEmployeeSyncExportProfileMap", {
            employeeSyncExportProfileMap: map
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
          });
        })
        .catch((e) => {
          return new Promise((resolve, reject) => {
            reject(e);
          });
        });
    }
  }
  GetEmployeeSyncExportProfileArray(force = false) {
    return this.GetEmployeeSyncExportProfileMap(force, true);
  }

  CalculateWorkDaysCount(date) {
    let storeSettings = this.store.state.storeSettings;
    let workDays = storeSettings ? storeSettings.workDays : [1, 2, 3, 4, 5];
    let start = date.clone().startOf("month");
    let end = start.clone().endOf("month").add(1, "days").startOf("day");
    let result = 0;
    while (end > start) {
      if (workDays.includes(start.isoWeekday())) {
        result += 1;
      }
      start = start.add(1, "days");
    }
    console.log("CalcWorkDays: " + result);
    return result;
  }

  CalculateDaysCount(date) {
    let start = date.clone().startOf("month");
    let end = start.clone().endOf("month").add(1, "days").startOf("day");
    let result = end.diff(start, "days");

    console.log("CalcDays: " + result);
    return result;
  }

  CalculateMonthWorkTime(workDays, days, weekTime, weekDays, monthAvgFactor) {
    let storeSettings = this.store.state.storeSettings;
    let mode = storeSettings ? storeSettings.workTimeMode : 0;
    let factor = monthAvgFactor ? monthAvgFactor / Math.pow(10, 7) : storeSettings ? storeSettings.workTimeFactor / Math.pow(10, 7) : 4.325;

    if (mode == 2) {
      let dayWorkTime = weekTime / 7;
      return Math.round(dayWorkTime * days);
    } else if (mode == 1) {
      let dayWorkTime = weekTime / weekDays;
      return Math.round(dayWorkTime * workDays);
    } else {
      return Math.round(weekTime * factor);
    }
  }

  // HELPERS FOR REPORTS
  reportDoc(title, subtitle = null, subtitle2 = null, userFullname = null, orientation = "p", headerImgData = null) {
    var doc = new jsPDF({
      orientation: orientation
    });
    var tmpFill = doc.getFillColor();
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();

    var y = 20;
    var headerRightOffset = orientation == "l" ? 265 : 178;
    var titleX = 14;
    if (headerImgData != null) {
      titleX = 33;
      doc.setFillColor(229, 21, 80);
      doc.rect(14, 16, 16, 16, "F");
      doc.addImage(headerImgData, "png", 14.5, 16.5, 15, 15);
    }

    doc.text(title, titleX, y);
    y += 5;
    doc.setFontSize(10);
    if (subtitle != null) {
      doc.text(subtitle, titleX, y);
      y += 4;
    }
    if (subtitle2 != null) {
      doc.text(subtitle2, titleX, y);
      y += 6;
    }
    doc.setFontSize(8);

    var created = this.getNowDateTimeString();
    doc.text("erstellt am: " + created, headerRightOffset, 20, {
      align: "right"
    });
    let logoImgData =
      "data:image/png;base64,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";
    doc.addImage(logoImgData, "png", headerRightOffset + 3, 17, 15, 15);
    if (userFullname != null)
      doc.text("erstellt von: " + userFullname, headerRightOffset, 24, {
        align: "right"
      });

    // reapply previous settings
    doc.addFileToVFS(DistrictProLight.fontName + ".ttf", DistrictProLight.font);
    doc.addFileToVFS(DistrictProMedium.fontName + ".ttf", DistrictProMedium.font);
    doc.addFileToVFS(DistrictProBold.fontName + ".ttf", DistrictProBold.font);
    doc.addFont(DistrictProLight.fontName + ".ttf", DistrictProLight.fontId, DistrictProLight.fontStyle);
    doc.addFont(DistrictProMedium.fontName + ".ttf", DistrictProMedium.fontId, DistrictProMedium.fontStyle);
    doc.addFont(DistrictProBold.fontName + ".ttf", DistrictProBold.fontId, DistrictProBold.fontStyle);

    doc.setFillColor(tmpFill);
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    doc.setFont(DistrictProBold.fontId, DistrictProBold.fontStyle);
    return {
      doc: doc,
      contentOffsetY: 35
    };
  }

  getImgFromUrl(logo_url, callback) {
    var img = new Image();
    img.src = logo_url;
    img.onload = function () {
      callback(img);
    };
  }

  employeeDataReportDoc(name, employeePictureData, logoImgData) {
    return this.reportDoc(name, "Personaldatenblatt", null, null, "p", employeePictureData);
  }

  tableReportDoc(headers, title, subtitle = null, subtitle2 = null, userFullname = null, orientationBreakpoint = 8) {
    var orientation = headers.length >= orientationBreakpoint ? "l" : "p";
    return this.reportDoc(title, subtitle, subtitle2, userFullname, orientation, null);
  }

  reportHeaderColorBlock(doc, title, offsetY) {
    var tmpFill = doc.getFillColor();
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();

    doc.setFillColor(229, 21, 80);
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFontStyle("bold");
    doc.rect(14, offsetY, 182, 10, "F");
    offsetY += 7;
    doc.text(title, 16, offsetY);
    offsetY += 8;

    // reapply previous settings
    doc.setFillColor(tmpFill);
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    doc.setFontStyle("normal");

    return doc, offsetY;
  }

  reportColorBlockDivider(doc, offsetY) {
    var tmpFill = doc.getFillColor();

    doc.setFillColor(200, 200, 200);
    doc.rect(14, offsetY, 182, 5, "F");
    offsetY += 10;

    // reapply previous settings
    doc.setFillColor(tmpFill);

    return doc, offsetY;
  }

  reportSubHeaderColorBlock(doc, title, offsetY) {
    var tmpFill = doc.getFillColor();
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();

    doc.setFillColor(229, 21, 80);
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFontStyle("bold");
    doc.rect(14, offsetY, 182, 10, "F");
    offsetY += 7;
    doc.text(title, 16, offsetY);
    offsetY += 8;

    // reapply previous settings
    doc.setFillColor(tmpFill);
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    doc.setFontStyle("normal");

    return doc, offsetY;
  }

  dataBlock(doc, data, offsetX, offsetY, page) {
    var tmpFill = doc.getFillColor();
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();
    var offset = {
      offsetY: offsetY,
      page: page
    };
    var lineHeight = 4;
    var left = 50 + offsetX;
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    data.forEach((d) => {
      var key = d.key;
      var value = d.value;
      doc.setFontStyle("normal");
      doc.text(key + (key != "" ? ":" : ""), left, offsetY, {
        align: "right"
      });
      doc.setFontStyle("bold");
      doc.text(value != null ? value : "", left + 3, offsetY);
      offsetY += lineHeight;
      doc, (offset = this.checkOffsetForNewPage(doc, offsetY, page));
      offsetY = offset.offsetY;
      page = offset.page;
    });

    // reapply previous settings
    doc.setFillColor(tmpFill);
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    doc.setFontStyle("normal");
    return (
      doc,
      {
        offsetY: offsetY,
        page: page
      }
    );
  }

  checkOffsetForNewPage(doc, offsetY, page) {
    // doc.rect(13.9, curY-0.2, 182.2, 297 - curY - 15);
    if (offsetY > 297 - 20) {
      var pageCount = doc.internal.getNumberOfPages();
      if (page == pageCount) {
        doc.addPage();
        page++;
      } else {
        page++;
        doc.setPage(page);
      }
      offsetY = 15;
      doc.rect(13.9, offsetY, 182.2, 297 - offsetY - 15);
      offsetY = 25;
    }

    return (
      doc,
      {
        offsetY: offsetY,
        page: page
      }
    );
  }

  insertPageNumbers(doc, landscape = false) {
    var tmpFontSize = doc.getFontSize();
    var tmpTextColor = doc.getTextColor();

    var offsetX = 105;
    var offsetY = 287;
    if (landscape) {
      offsetX = 148.5;
      offsetY = 200;
    }

    doc.setFontStyle("normal");
    doc.setFontSize(6);
    doc.setTextColor(60, 60, 60);

    var pageCount = doc.internal.getNumberOfPages();
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.text("Seite " + i + " von " + pageCount, offsetX, offsetY, {
        align: "center"
      });
    }
    doc.setFontSize(tmpFontSize);
    doc.setTextColor(tmpTextColor);
    return doc;
  }

  getImageDataUri(url, cb) {
    var image = new Image();
    image.setAttribute("crossOrigin", "anonymous"); //getting images from external domain

    image.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;

      //next three lines for white background in case png has a transparent background
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff"; /// set white fill style
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      canvas.getContext("2d").drawImage(this, 0, 0);

      cb(canvas.toDataURL("image/jpeg"));
    };

    image.src = url;
  }

  ProcessNumericLabel(label, decimals = 2, divider = ",", plusSign = true) {
    let number = parseFloat(label);
    if (!isNaN(number)) {
      number = (Math.round(number * 100) / 100).toFixed(decimals);
      if (plusSign) {
        number = (number < 0 ? "" : "+") + number;
      }
      label = number.toString().replace(".", divider);
    }
    return label;
  }

  GetSnapShot(el, name, callbackSnapTaken) {
    let box = el.getBoundingClientRect();
    html2canvas(el, {
      //canvas:canvas,
      height: 1920,
      width: 1080
    })
      .then((canvas) => {
        let image = canvas.toDataURL("image/png");
        let imageDownloadElement = document.createElement("a");
        imageDownloadElement.href = image;
        imageDownloadElement.download = (name ? name : "download") + ".png";
        document.body.appendChild(imageDownloadElement);
        imageDownloadElement.click();
        document.body.removeChild(imageDownloadElement);
        if (callbackSnapTaken) callbackSnapTaken();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  DragOpenedCheck() {
    return window.app.genericPopups.find((p) => p.draggable);
  }

  OpenListLabel(labels, options) {
    let defaultState = {
      components: [
        {
          type: "listlabel",
          state: {
            labels: labels
          }
        }
      ],
      listStyle: true,
      noScroll: true,
      pointerDirection: 3,
      elRelative: null,
      pointerOffset: 0,
      pointerHide: true,
      pinTopRight: true
    };
    if (options) for (let x in options) defaultState[x] = options[x];
    /*if(defaultState.elRelative) {
        defaultState.offsety = defaultState.elRelative.getBoundingClientRect().height / 2;
    }*/

    this.OpenPopup(defaultState);
  }

  TimeBarDragCheck(shift) {
    var shiftDragged = shift;
    return (elementOnMouseCursor) => {
      let timebar = $(elementOnMouseCursor).closest(".time-bar-new")[0];

      if (timebar) {
        console.log("timebar dragged unto");
        timebar = timebar.__vue__;
        timebar.AddTimeFrameDrag(shiftDragged);
      }
    };
  }

  EndShiftDrag(rosterView, dropdowncontainer) {
    $(".dragged-shift").removeClass("dragged-shift");
    $(".shift-drag-overlay").css("display", "");
    rosterView.dragging = false;
    rosterView.ClearEmployeeFilter();
    dropdowncontainer.Close();
    window.app.MouseMoveUnsubscribe("TimeBarShiftDragCheck");
    if (window.timebars) {
      window.timebars.filter((t) => t).forEach((t) => (t.timeFrameDrag = null));
    }
  }

  DragShift(shifts, rosterView, shiftDraggedElement) {
    if (shifts && !shifts.length) {
      let array = [];
      array.push(shifts);
      shifts = array;
    }
    if (!shifts || shifts.length === 0 || shifts[0].length === 0 || !shifts.find((s) => !s.published)) return;
    let view = this;
    setTimeout(function () {
      if (!window.mouse.click) return;
      window.app.MouseMoveSubscribe("TimeBarShiftDragCheck", view.TimeBarDragCheck(shifts[0]));
      rosterView.dragging = true;
      shifts.forEach((s) => rosterView.FilterSpot(s.spotId, true));
      rosterView.filterEmployees();
      if (shiftDraggedElement) {
        let draggedBox = shiftDraggedElement.getBoundingClientRect();
        $(shiftDraggedElement).addClass("dragged-shift");
        requestAnimationFrame(function () {
          $(".shift-drag-overlay").css("display", "inline-block");
          let firstWeek = $(".entry > .week:first-child")[0].getBoundingClientRect();
          let lastWeek = $(".entry > .week:last-child")[0].getBoundingClientRect();
          $(".shift-drag-overlay.left").css({
            width: draggedBox.left - firstWeek.left + "px",
            left: firstWeek.left + "px"
          });
          $(".shift-drag-overlay.right").css({
            left: draggedBox.right + "px",
            width: lastWeek.right - draggedBox.right + "px"
          });
        });
      }
      let components = [];
      let draggedUntoSelection = {};
      for (let x in shifts) {
        components.push({
          type: "rosterday",
          state: {
            shifts: shifts,
            spotMap: rosterView.spotMap
          },
          /*propContainer: {
              eventProp: rosterView.GetTimeBarShiftProp(rosterView.planShiftMomentMap[shifts[x].id].fromDate, shifts[x]),
              class: shifts[x].published ? 'published' : '',
          },*/
          customEvent: {},
          click: (dropdowncontainer, component) => {
            if (draggedUntoSelection.shifts.length > 0) {
              rosterView.$helpers.OpenShiftDragSubMenu(shifts[0], draggedUntoSelection, component.$el, dropdowncontainer, rosterView);
            } else {
              rosterView.UpdateShift(component.eventProp.timeFrames[0].shift, {
                employeeId: draggedUntoSelection.employee.id
              });
              view.EndShiftDrag(rosterView, dropdowncontainer);
            }
          }
        });
      }
      rosterView.$helpers.OpenPopup({
        components: components,
        listStyle: true,
        noScroll: true,
        draggable: true,
        remainAfterSelect: true,
        allowOverflow: true,
        callbackDrag: (element, dropdowncontainer) => {
          if ($(element).closest(".shifts")[0]) {
            rosterView.UpdateShift(shifts[0], {
              employeeId: null
            });
            view.EndShiftDrag(rosterView, dropdowncontainer);
            return;
          }
          let day = $(element).closest(".entry:not(.header) .day")[0];
          if (day) {
            draggedUntoSelection.employee = rosterView.employeeMap[day.attributes.employeeid.value];
            draggedUntoSelection.shifts = rosterView.rosterContentMap[day.attributes.employeeid.value][day.attributes.date.value].planShifts;
            draggedUntoSelection.date = rosterView.$helpers.getMomentFromStringTZ(day.attributes.date.value);
            if (draggedUntoSelection.shifts.length === 0 && shifts.length === 1) {
              rosterView.UpdateShift(shifts[0], {
                employeeId: draggedUntoSelection.employee.id
              });
              view.EndShiftDrag(rosterView, dropdowncontainer);
            }
            if (draggedUntoSelection.shifts.length === 1 && shifts.length === 1) {
              if (draggedUntoSelection.employee.id === shifts[0].employeeId) {
                view.EndShiftDrag(rosterView, dropdowncontainer);
              } else {
                rosterView.$helpers.OpenShiftDragSubMenu(shifts[0], draggedUntoSelection, day, dropdowncontainer, rosterView);
                requestAnimationFrame(function () {
                  view.EndShiftDrag(rosterView, dropdowncontainer);
                });
              }
            }
          } else {
            let timebar = $(element).closest(".time-bar-new")[0];

            if (timebar) {
              timebar = timebar.__vue__;
              draggedUntoSelection.employee = timebar.eventProp.employee;

              draggedUntoSelection.shifts = timebar.timeFrames.filter((t) => t.type == "shift").map((t) => t.shift);
              let array = [];

              draggedUntoSelection.shifts.forEach((s) => {
                if (!array.find((a) => a.id === s.id)) {
                  if (rosterView.planShiftMomentMap[s.id] && rosterView.planShiftMomentMap[s.id].fromDate.date() === timebar.eventProp.day.date()) array.push(s);
                  if (rosterView.actualShiftMomentMap[s.id] && rosterView.actualShiftMomentMap[s.id].fromDate.date() === timebar.eventProp.day.date()) array.push(s);
                }
              });
              draggedUntoSelection.shifts = array;
              draggedUntoSelection.date = timebar.eventProp.day.clone();
              if (draggedUntoSelection.shifts.length === 0 && shifts.length === 1) {
                rosterView.UpdateShift(shifts[0], {
                  employeeId: draggedUntoSelection.employee.id
                });
                view.EndShiftDrag(rosterView, dropdowncontainer);
              }
              if (draggedUntoSelection.shifts.length === 1 && shifts.length === 1) {
                if (draggedUntoSelection.employee.id === shifts[0].employeeId) {
                  view.EndShiftDrag(rosterView, dropdowncontainer);
                } else {
                  rosterView.$helpers.OpenShiftDragSubMenu(shifts[0], draggedUntoSelection, null, dropdowncontainer, rosterView);
                  requestAnimationFrame(function () {
                    view.EndShiftDrag(rosterView, dropdowncontainer);
                  });
                }
              }
            } else {
              view.EndShiftDrag(rosterView, dropdowncontainer);
            }
          }
        }
      });
    }, 200);
  }

  OpenShiftDragSubMenu(shift, draggedUntoSelection, element, dropdowncontainer, rosterView) {
    let labelOptions = [];
    let helpers = this;
    let view = this;

    let overlap = draggedUntoSelection.shifts.find((s) => helpers.CheckTimeFrameIntersect(rosterView.planShiftMomentMap[shift.id].fromDate, rosterView.planShiftMomentMap[shift.id].toDate, rosterView.planShiftMomentMap[s.id].fromDate, rosterView.planShiftMomentMap[s.id].toDate));

    let addOption = {
      text: this.i18n.t('comp.help.add'),
      type: "block",
      click: () => {
        rosterView.UpdateShift(shift, {
          employeeId: draggedUntoSelection.employee.id
        });
        view.EndShiftDrag(rosterView, dropdowncontainer);
      }
    };

    if (overlap) {
      addOption.disabled = true;
      addOption.tooltip = this.i18n.t('comp.help.overlap');
    }

    labelOptions.push(addOption);
    let draggedUntoShift = draggedUntoSelection.shifts[0];
    if (draggedUntoShift) {
      labelOptions.push({
        text: this.i18n.t('comp.help.swap'),
        type: "block",
        click: () => {
          let draggedEmployeeId = shift.employeeId;
          let shiftUpdateRequests = [];
          shiftUpdateRequests.push({
            shift: shift,
            fields: {
              employeeId: draggedUntoSelection.employee.id
            }
          });
          shiftUpdateRequests.push({
            shift: draggedUntoShift,
            fields: {
              employeeId: draggedEmployeeId
            }
          });
          rosterView.UpdateShiftMulti(shiftUpdateRequests);
          //rosterView.UpdateShift(shift, {employeeId: draggedUntoSelection.employee.id});
          //rosterView.UpdateShift(draggedUntoSelection.shifts[0], {employeeId: draggedEmployeeId});
          console.log("Tauschen " + draggedUntoSelection.employee.firstName);
          view.EndShiftDrag(rosterView, dropdowncontainer);
        },
        disabled: draggedUntoShift.published,
        tooltip: draggedUntoShift.published ? this.i18n.t('comp.help.alreadyPublished') : null
      });
      labelOptions.push({
        text: this.i18n.t('comp.help.replace'),
        type: "block",
        click: () => {
          rosterView.UpdateShift(shift, {
            employeeId: draggedUntoSelection.employee.id
          });
          rosterView.UpdateShift(draggedUntoShift, {
            employeeId: null
          });
          console.log("Ersetzen " + draggedUntoSelection.employee.firstName);
          view.EndShiftDrag(rosterView, dropdowncontainer);
        },
        disabled: draggedUntoShift.published,
        tooltip: draggedUntoShift.published ? this.i18n.t('comp.help.alreadyPublished') : null
      });
    }

    rosterView.$helpers.OpenListLabel(labelOptions, {
      elRelative: element,
      pointerHide: true,
      pointerDirection: 3
    });
  }

  CheckTimeFrameIntersect(startA, endA, startB, endB) {
    return startA < endB && startB < endA;
  }

  IsKeyNameNavigationType(keyName) {
    return keyName === "Home" || keyName === "End" || keyName === "PageUp" || keyName === "PageDown" || keyName === "ArrowLeft" || keyName === "ArrowRight" || keyName === "Backspace" || keyName === "Delete" || keyName === "Tab" || keyName === "Shift";
  }

  OpenDatepickerPopup(dateOptions, dateEvents, popupOptions) {
    /* example datepicker
        dateOptions = {viewsEnabled: ['W','M','Y','C'], date: dateMoment}
        dateEvents = {
            OnDateSelect: (date) => {...}, //always called to avoid having to define it x5 for a generic date pick
            OnWeekSelect: (date) => {...}, //you don't have to define these or OnDateSelect if you're not using them
            OnDaySelect: (date) => {...},
            OnMonthSelect: (date) => {...},
            OnYearSelect: (date) => {...},
            OnCalendarSelect: (date) => {...},
        };
        popupOptions: {elRelative: $event.currentTarget} // if elRelative isn't defined the popup will open on the cursor so no big deal
    */
    let defaultState = {
      components: [
        {
          type: "datepicker",
          state: dateOptions,
          customEvents: dateEvents
        }
      ],
      noScroll: false,
      pointerDirection: 3,
      elRelative: null,
      pointerOffset: 0,
      pointerHide: true,
      pinTopRight: true,
      expanded: true
    };
    if (popupOptions) for (let x in popupOptions) defaultState[x] = popupOptions[x];

    this.OpenPopup(defaultState);
  }

  GetContrastingColor(hex, lightcolor = "white", darkcolor = "#444444", contrastLimit = 80) {
    if (!hex) return darkcolor;
    let hsl = this.hexToHSLObject(hex);
    if (hsl.l < contrastLimit) return lightcolor;
    else return darkcolor;
  }

  OpenDragPopup(popupOptions, dragEndCallback = (elementOnMouse, dropdowncontainer) => {}) {
    let defaultState = {
      components: [],
      listStyle: true,
      noScroll: true,
      draggable: true,
      remainAfterSelect: true,
      callbackDrag: dragEndCallback
    };
    if (popupOptions) for (let x in popupOptions) defaultState[x] = popupOptions[x];
    this.OpenPopup(defaultState);
  }

  SetMomentTimeFromMoment(momentExisting, momentToCopy) {
    momentExisting.year(momentToCopy.year());
    momentExisting.month(momentToCopy.month());
    momentExisting.date(momentToCopy.date());
    momentExisting.hours(momentToCopy.hours());
    momentExisting.minutes(momentToCopy.minutes());
    momentExisting.seconds(momentToCopy.seconds());
    momentExisting.milliseconds(momentToCopy.milliseconds());
    return momentExisting;
  }

  GetHourMinuteFormatFromTotal(total) {
    if (!total) return "--:--";
    if (!total.totalActual) return this.GetHourMinuteFormatFromMilliseconds(total.total + total.totalPreviousDay);
    return this.GetHourMinuteFormatFromMilliseconds(total.totalActual + total.totalActualPreviousDay);
  }

  GetHourMinuteFormatFromMap(map, format) {
    if (!map || !map[format]) return "--:--";
    return this.GetHourMinuteFormatFromTotal(map[format]);
  }

  GetHourMinuteFormatFromMilliseconds(milliseconds) {
    if (!milliseconds) return "--:--";
    let seconds = milliseconds / 1000;
    let minutes = seconds / 60;

    let hours = (minutes - (minutes % 60)) / 60;
    minutes = Math.ceil(minutes % 60);
    if (minutes === 60) {
      hours++;
      minutes = 0;
    }
    if (minutes < 10) minutes = "0" + minutes;
    if (hours < 10) hours = "0" + hours;

    return hours + "h:" + minutes + "m";
  }

  GetMillisecondTotalObjectFromMoments(from, to, timeBorderMoment) {
    let difference = 0;
    let remaining = 0;
    if (!timeBorderMoment) {
      difference += to._d.getTime() - from._d.getTime();
    } else {
      if (to < timeBorderMoment) {
        difference += to._d.getTime() - from._d.getTime();
      } else {
        difference += timeBorderMoment._d.getTime() - from._d.getTime();
        remaining += to._d.getTime() - timeBorderMoment._d.getTime();
      }
    }
    return {
      total: difference,
      totalOutOfRange: remaining
    };
  }
  //example

  //this.$helpers.OpenColorSelection(
  //  (color) => {
  //      store.color = color;
  //      view.$forceUpdate();
  //  },
  //  {
  //      header: 'Wahl-Farben',
  //      colorSelection: this.spotsStructured.map(s => { return s.color}),
  //      colorSelected: store.color,
  //      colorBlacklist: this.spotsStructured.map(s => { return {color: s.color, label: s.name}})
  //  }
  //);
  //
  //or just for default values
  //this.$helpers.OpenColorSelection((color) => { store.color = color; }},

  OpenColorSelection(callback, options = {}) {
    this.OpenPopup({
      expanded: true,
      noScroll: true,
      header: options.header ? options.header : this.i18n.t('comp.help.choiceColors'),
      components: [
        {
          type: "colorselection",
          customEvents: {
            ApplyColor: callback
          },
          propContainer: {
            color: options.colorSelected,
            colorSelection: options.colorSelection,
            colorBlacklist: options.colorBlacklist
          }
        }
      ]
    });
  }

  ValidEmailCheck(email) {
    let emailPattern = new RegExp("(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])");
    return emailPattern.test(email);
  }

  OpenInfoPopup(header, descriptionLines, callbackAccept, callbackCancel) {
    let view = this;
    let entries = [];
    descriptionLines = descriptionLines.filter((l) => l && l !== "");
    for (let x in descriptionLines) {
      let style = {
        "text-align": "left"
      };
      let entry = {
        key: "info" + x,
        type: "output",
        value: descriptionLines[x],
        dataStyles: style
      };
      if (x == descriptionLines.length - 1)
        entry.styles = {
          "margin-bottom": "-20px"
        };
      entries.push(entry);
    }
    let callbackAcceptWrapper;
    if (!callbackAccept)
      callbackAcceptWrapper = (entries, datafill) => {
        datafill.$parent.locked = false;
      };
    else
      callbackAcceptWrapper = (entries, datafill) => {
        datafill.locked = false;
        callbackAccept(entries, datafill);
      };
    let callbackCancelWrapper = undefined;
    if (callbackCancel)
      callbackCancelWrapper = (entries, datafill) => {
        datafill.$parent.locked = false;
        callbackCancel(entries, datafill);
      };
    this.OpenPopup({
      header: header,
      width: "500px",
      components: [
        {
          type: "datafill",
          state: {
            entries: entries,
            selectCallback: callbackAcceptWrapper,
            deleteCallback: callbackCancelWrapper,
            positiveButtonLabel: this.i18n.t('employee.data.ok'),
            negativeButtonLabel: this.i18n.t('settings.ui.cancel')
          }
        }
      ],
      centered: true,
      locked: true
    });
  }

  MountViewOnDropdownContainer(view, options) {
    let state = {
      show: true,
      toggled: true,
      centered: true,
      expanded: true
    };

    for (let o in options) {
      state[o] = options[o];
    }
    let containerState = this.OpenPopup(state);
    requestAnimationFrame(function () {
      let container = window.app.$children.find((c) => c.state === containerState);
      if (container) {
        container.$el.querySelector(".tab-body").appendChild(view.$el);
        view.containerEl = container.$el;
        container.toggled = true;
        container.show = true;
        view.CloseCallback = () => {
          container.locked = false;
          requestAnimationFrame(function () {
            container.$emit("on-close", container);
          });
          /*view.$destroy();
          container.$destroy();*/
        };
        view.$once("hook:beforeDestroy", () => {
          container.locked = false;
          container.$emit("on-close", container);
          view.$destroy();
          container.$destroy();
        });
      }
    });
  }

  isFunction(x) {
    return Object.prototype.toString.call(x) == "[object Function]";
  }

  b64DecodeUnicode(str) {
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  }

  b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode('0x' + p1);
        }));
  }

  forceFileDownload(content, title, includeBom = false) {
    const url = window.URL.createObjectURL(new Blob(includeBom ? ["\uFEFF", content] : [content]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", title);
    document.body.appendChild(link);
    link.click();
  }

  convertToUInt8(content) {
    for (var c = content.length, e = new Uint8Array(new ArrayBuffer(c)), d = 0; d < c; d++) e[d] = content.charCodeAt(d);
    return e;
  }

  GetExportSettingsMap(force = false, asArray = false) {
      if (this.store.state.exportSettingsMap && this.store.state.exportSettingsMapState.companyId == this.store.state.companyId && !force) {
          return new Promise((resolve, reject) => {
              resolve(this.returnObj(this.store.state.exportSettingsMap, asArray));
          });
      } else {
          let params = {

          };
          return this.GetCall('/api/sec/report/settings', params).then((response) => {
              let map = {};
              response.data.forEach(item => {
                  map[item.id] = item;
              });

              this.store.commit('setExportSettingsMap', {
                  exportSettingsMap: map
              });
              return new Promise((resolve, reject) => {
                  resolve(this.returnObj(map, asArray));
              });
          }).catch((e) => {
              return new Promise((resolve, reject) => {
                  reject(e);
              });
          });
      }
  }

  CreateExportSetting(exportSetting, type){
      let view = this;
      let url = '/api/sec/report/settings';
      url = this.appendParam("companyId", this.store.state.companyId, url, '/api/sec/report/settings');

      let payload = {
          companyId: this.store.state.companyId,
          type: type,
          name: exportSetting.name,
          setting: exportSetting.setting
      };

      axios({
          method: 'post',
          headers: {
            AUTHORIZATION: "Bearer " + this.store.state.jwt
          },
          url: url,
          data: payload
      }).then(response => {
          let exportSetting = response.data;
          console.log(exportSetting);
          view.store.commit("setExportSettingsMapEntry", exportSetting);

          view.success(this.i18n.t('employee.doc.createSuccess'), this.i18n.t('comp.help.reportSettingCreated'));

      }).catch(function (error) {
          console.log(error);

          view.error(this.i18n.t('comp.help.createFailed'), this.i18n.t('comp.help.reportSettingCreateError'));
      })
  }

  UpdateExportSetting(exportSetting){
      let view = this;
      let url = '/api/sec/report/settings';
      url = this.appendParam("companyId", this.store.state.companyId, url, '/api/sec/report/settings');

      let payload = {
          id: exportSetting.id,
          companyId: this.store.state.companyId,
          name: exportSetting.name,
          setting: exportSetting.setting
      };

      axios({
          method: 'put',
          headers: {
            AUTHORIZATION: "Bearer " + this.store.state.jwt
          },
          url: url,
          data: payload
      }).then(response => {
          let texportSetting = view.store.state.exportSettingsMap ? view.store.state.exportSettingsMap[exportSetting.id] : null;
          if(texportSetting){
              texportSetting.name = exportSetting.name;
              texportSetting.setting = exportSetting.setting;
              view.store.commit("setExportSettingsMapEntry", texportSetting);
          }


          view.success(this.i18n.t('comp.help.editSuccess'), this.i18n.t('comp.help.reportSettingEdited'));
      }).catch(function (error) {
          view.error(this.i18n.t('comp.help.editFailed'), this.i18n.t('comp.help.reportSettingEditError'));
      })
  }


  DownloadFileFromFileServer(url, filename, fileending = null){
      let finalUrl = url+"&dl=true"+"&filename="+filename;
      if(fileending != null){
          finalUrl += "."+fileending;
      }
      window.open(finalUrl);
  }

  GetEmployeeDocumentsMap(force = false, asArray = false) {
      if (this.store.state.employeeDocumentMap && this.store.state.employeeDocumentMapState.companyId == this.store.state.companyId && !force) {
          return new Promise((resolve, reject) => {
              resolve(this.returnObj(this.store.state.employeeDocumentMap, asArray));
          });
      } else {
          let map = {};
          let paramsProxyCall = {};
          let paramsMlDocumentsCall = {};
          return this.GetCall('/api/sec/proxy/md/employee/documents', paramsProxyCall)
          .then((response) => {
              response.data.forEach(employeeDocument => {
                employeeDocument.employeeId = employeeDocument.remoteId;
                delete employeeDocument.remoteId;
                employeeDocument.created_at = employeeDocument.creationDate;
                delete employeeDocument.creationDate;
                employeeDocument.proxyDocument = true;
                map[employeeDocument.id] = employeeDocument;
              });

              return this.GetCall('/api/sec/employee/documents', paramsMlDocumentsCall);
          }).then((response) => {
            response.data.forEach(employeeDocument => {
              employeeDocument.proxyDocument = false;
              map[employeeDocument.id] = employeeDocument;
            });

            this.store.commit('setEmployeeDocumentMap', {
                employeeDocumentMap: map
            });
            return new Promise((resolve, reject) => {
                resolve(this.returnObj(map, asArray));
            });
          }).catch((e) => {
              return new Promise((resolve, reject) => {
                  reject(e);
              });
          });
      }
  }

  GetExternalSoftwaresMap(force = false, asArray = false) {
      if (this.store.state.externalSoftwaresMap && this.store.state.externalSoftwaresMapState.companyId == this.store.state.companyId && !force) {
          return new Promise((resolve, reject) => {
              resolve(this.returnObj(this.store.state.externalSoftwaresMap, asArray));
          });
      } else {
          let params = {

          };
          return this.GetCall('/api/sec/externalsoftware', params).then((response) => {
              let map = {};

              response.data.forEach(item => {
                  map[item.id] = item;
              });

              this.store.commit('setExternalSoftwaresMap', {
                  externalSoftwaresMap: map
              });
              return new Promise((resolve, reject) => {
                  resolve(this.returnObj(map, asArray));
              });
          }).catch((e) => {
              return new Promise((resolve, reject) => {
                  reject(e);
              });
          });
      }
  }

  SetExternalSoftwareActive(externalSoftware){
      let view = this;
      let url = '/api/sec/externalsoftware/' + externalSoftware.id + '/' + (externalSoftware.active ? '1' : '0');
      url = this.appendParam("companyId", this.store.state.companyId, url, url);

      axios({
          method: 'put',
          headers: {
            AUTHORIZATION: "Bearer " + this.store.state.jwt
          },
          url: url,
          data: null
      }).then(response => {
          let texternalSoftware = view.store.state.externalSoftwaresMap ? view.store.state.externalSoftwaresMap[externalSoftware.id] : null;
          if(texternalSoftware){
              texternalSoftware.active = externalSoftware.active;
              view.store.commit("setExternalSoftwaresMapEntry", texternalSoftware);
          }

          view.success(this.i18n.t('comp.help.editSuccess'), this.i18n.t('comp.help.externalSoftwareEdited'));
      }).catch(function (error) {
          view.error(this.i18n.t('comp.help.editFailed'), this.i18n.t('comp.help.externalSoftwareEditError'));
      })
  }

  calculateIndividualWageTypeExport(entity){
    let view = this;

    let url = "/api/sec/individualWageTypeExport";
    let baseUrl = "/api/sec/individualWageTypeExport";
    url = this.appendParam("companyId", this.store.state.companyId, url, baseUrl);
    url = this.appendParam("year", entity.year, url, baseUrl);
    url = this.appendParam("month", entity.month, url, baseUrl);
    url = this.appendParam("sessionId", entity.sessionId, url, baseUrl);
    url = this.appendParam("storeIds", JSON.stringify([entity.storeId]), url, baseUrl);
    return axios({
      method: "get",
      headers: {
        AUTHORIZATION: "Bearer " + this.store.state.jwt,
      },
      url: url,
    });
  }

  getIndividualWageTypeExportPdfReport(entity){
    let view = this;

    let url = "/api/sec/individualWageTypePdfReport";
    let params = {
      "companyId": this.store.state.companyId,
    }
    let payload = {
      "year": entity.year,
      "month": entity.month,
      "sessionId": entity.sessionId,
      "storeIds": entity.storeIds,
      "options": entity.options,
      "exportJson": entity.exportJson,
    };
    return axios({
      method: "post",
      params: params,
      headers: {
        AUTHORIZATION: "Bearer " + this.store.state.jwt
      },
      url: url,
      data: payload
    });
  }

  getIndividualWageTypeExportPdfReportWithSetting(entity){
    let view = this;

    let url = "/api/sec/individualWageTypePdfReportWithSetting";
    let params = {
      "companyId": this.store.state.companyId,
    }
    let payload = {
      "year": entity.year,
      "month": entity.month,
      "exportSettingsId": entity.exportSettingsId,
      "sessionId": entity.sessionId,
      "options": entity.options
    };
    return axios({
      method: "post",
      params: params,
      headers: {
        AUTHORIZATION: "Bearer " + this.store.state.jwt
      },
      url: url,
      data: payload
    });
  }

  generateIndividualWageTypeExportPDF(entry, employeeMapById, contracts, models, store, userFullname) {
    let employmentModels = [];
    let exportJson = JSON.parse(entry.exportJson);

    // all emps
    if (entry.options.employeeSelection == 1) {
      Object.values(employeeMapById).filter(e => e.isHidden === 0 && (entry.storeId ? e.storeId === entry.storeId : true) && !Object.keys(exportJson.employees).includes(""+e.id)).forEach(e => {
        exportJson.employees[e.id] = {
            id: e.id,
            employee: e,
            firstName: e.firstName,
            lastName: e.lastName,
            mdPersonnelId: e.mdPersonnelId,
            storeId: e.storeId,
            days: [],
            addedForShowOnly: true,
          };
      });
    // all emps with active contract
    } else if (entry.options.employeeSelection == 2) {
      let currentMonth = entry.month;
      let currentYear = entry.year;
      let currentMomentStart = this.getMomentFromStringTZ(currentYear + "-" + currentMonth + "-01", "YYYY-M-DD").startOf('month');
      let currentMomentEnd = currentMomentStart.clone().add(1, "months");

      // console.log("currentMomentStart", currentMomentStart.format("YYYY-MM-DD HH:mm:ss"));
      // console.log("currentMomentEnd", currentMomentEnd.format("YYYY-MM-DD HH:mm:ss"));

      Object.values(employeeMapById).filter(e => e.isHidden === 0 && (entry.storeId ? e.storeId === entry.storeId : true) && !Object.keys(exportJson.employees).includes(""+e.id)).forEach(e => {
        if (contracts[e.id] && contracts[e.id].length > 0) {
          // console.log("has contracts");
          contracts[e.id].forEach(c => {
            let fromMoment = this.getMomentFromStringTZ(c.from);
            let toMoment = c.to ? this.getMomentFromStringTZ(c.to) : this.getMomentFromStringTZ("2999-12-31", "YYYY-M-DD");

            // console.log("fromMoment", fromMoment.format("YYYY-MM-DD HH:mm:ss"));
            // console.log("toMoment", toMoment.format("YYYY-MM-DD HH:mm:ss"));

            if (fromMoment.isBefore(currentMomentEnd) && toMoment.isAfter(currentMomentStart)) {
              // console.log("contract is active");
              exportJson.employees[e.id] = {
                  id: e.id,
                  employee: e,
                  firstName: e.firstName,
                  lastName: e.lastName,
                  mdPersonnelId: e.mdPersonnelId,
                  storeId: e.storeId,
                  days: [],
                  addedForShowOnly: true,
                };
            }
          });
        }
      });
    }

    // defaultModel
    let defaultModel = models.find(m => m.isDefault === 1);

    Object.values(exportJson.employees).forEach(e => {
      e.employee = employeeMapById[e.id];
      if (e.employee) {
        let employeeEmploymentModelId = e.employee.employmentModelId;
        if (!employeeEmploymentModelId && defaultModel) {
          employeeEmploymentModelId = defaultModel.id;
        }
        if (!(entry.options.employmentModelsBool || entry.options.employmentModels.includes(employeeEmploymentModelId))) {
          // the employees employmentModel is not selected - removing data
          if ([1,2].includes(entry.options.employeeSelection)) {
            // if all employees or all employees with active contract are selected, we need to keep the employee in the export
            e.addedForShowOnly = true;
          }
          e.days = [];
        }
        if (entry.options.groupBy == 1) {
          // group by employmentModel
          if (!employmentModels.hasOwnProperty(employeeEmploymentModelId)) {
            employmentModels[employeeEmploymentModelId] = {
              model: models.find(m => m.id === employeeEmploymentModelId),
              employees: [],
            };
          }
          employmentModels[employeeEmploymentModelId].employees.push(e);
        } else {
          // default -- do not group
          if (!employmentModels.hasOwnProperty(0)) {
            employmentModels[0] = {
              model: null,
              employees: [],
            };
          }
          employmentModels[0].employees.push(e);
        }
      } else {
        // employee not found - removing data
        e.days = [];
      }
    });

    let headers = [
      { content: this.i18n.t('comp.help.transactionDate'), colSpan: 1, styles: { halign: 'left' } },
      { content: 'EarnCode', colSpan: 1, styles: { halign: 'right' } },
      { content: this.i18n.t('settings.centers.desc'), colSpan: 1, styles: { halign: 'left' } },
      { content: this.i18n.t('comp.help.days'), colSpan: 1, styles: { halign: 'right' } },
      { content: this.i18n.t('comp.help.hours'), colSpan: 1, styles: { halign: 'right' } },
      { content: this.i18n.t('comp.help.factor'), colSpan: 1, styles: { halign: 'right' } },
      { content: this.i18n.t('employee.comp.salary'), colSpan: 1, styles: { halign: 'right' } },
    ];

    entry.created_at = entry.created_at ? this.getMomentFromString(entry.created_at, "YYYY-MM-DDTHH:mm:ssZ").format("YYYY-MM-DD_HH-mm-ss") : this.getMomentTZ().format("YYYY-MM-DD_HH-mm-ss");
    entry.sotecStoreId = entry.sotecStoreId ? entry.sotecStoreId : (store ? store.name.replaceAll(" ", "_") : this.store.state.companyData.label.replaceAll(" ", "_"));
    let filename = 'Export_' + entry.sotecStoreId + "_" + entry.created_at + '.pdf';
    let body = [];
    let repDoc = this.tableReportDoc(
        headers,
        this.i18n.t('comp.help.exportOverview') + ' ' + this.monthName(entry.month - 1) + ' ' + entry.year,
        this.store.state.companyData.label,
        store ? store.name + ", " + store.description : "",
        userFullname,
        9
    );
    let doc = repDoc.doc;
    doc.setProperties({
      title: this.i18n.t('comp.help.exportOverview')
    });
    let contentOffsetY = repDoc.contentOffsetY;
    doc.setFontSize(12);

    let totalSums = [0, 0, 0];
    let totalWageTypeSums = {};

    if (entry.options.showOnlySums && !entry.options.employeeSums && exportJson.errors && "85" in exportJson.errors && exportJson.errors["85"].length > 0) {
      body.push([]);
      body.push([{
        content: this.i18n.t('comp.help.avgValuesMissing', {count: exportJson.errors["85"].length}),
        colSpan: 7,
        styles: {fillColor: [200, 0, 0], textColor: [255, 255, 255]}
      }]);
    }

    for (let employmentModelId in employmentModels) {

      let employmentModel = employmentModels[employmentModelId];
      let employmentModelSums = [0, 0, 0];
      let employmentModelWageTypeSums = {};
      let employmentModelRowCount = 0;

      employmentModel.employees.sort((a, b) => {
        if (entry.options.sortEmployeesBy === 0) {
          if (a.employee.lastName > b.employee.lastName) {
            return 1;
          } else if (a.employee.lastName < b.employee.lastName) {
            return -1;
          } else {
            if (a.employee.firstName > b.employee.firstName) {
              return 1;
            } else {
              return -1;
            }
          }
        } else {
          if (a.employee.mdPersonnelId > b.employee.mdPersonnelId) {
            return 1;
          } else {
            return -1;
          }
        }
      });

      for (let employeeIdx in employmentModel.employees) {

        let employee = employmentModel.employees[employeeIdx];
        let weeklyContractHours = "-";
        let countWeeklyContractHours = 0;
        let paymentText = "";
        let paymentValue = "-";
        let countPaymentValue = 0;

        let tmpCurrentMomentStart = this.getMomentFromStringTZ(entry.year + "-" + entry.month + "-01", "YYYY-M-DD").startOf("month");
        let tmpCurrentMomentEnd = tmpCurrentMomentStart.clone().add(1, "months");
        if (contracts[employee.id] && contracts[employee.id].length > 0) {
          contracts[employee.id].forEach((c) => {
            let fromMoment = this.getMomentFromStringTZ(c.from);
            let toMoment = c.to ? this.getMomentFromStringTZ(c.to) : this.getMomentFromStringTZ("2999-12-31", "YYYY-M-DD");
            if (fromMoment.isBefore(tmpCurrentMomentEnd) && toMoment.isAfter(tmpCurrentMomentStart)) {
              if (Math.round(c.weekTimeRegular / 60.0) != weeklyContractHours) {
                countWeeklyContractHours++;
              }
              weeklyContractHours = Math.round(c.weekTimeRegular / 60.0);

              if (Math.round(c.payment + c.extraPayment) / 100.0 != paymentValue) {
                countPaymentValue++;
              }
              paymentValue = Math.round(c.payment + c.extraPayment) / 100.0;
              if (c.paymentType == 1) {
                paymentText = this.i18n.t('comp.help.salary');
              } else {
                if (c.wageType == 1) {
                  paymentText = this.i18n.t('comp.help.hourlyWage');
                } else if (c.wageType == 2) {
                  paymentText = this.i18n.t('comp.help.dailyRate');
                } else if (c.wageType == 3) {
                  paymentText = this.i18n.t('comp.help.weeklyRate');
                } else if (c.wageType == 4) {
                  paymentText = this.i18n.t('comp.help.monthlyRate');
                }
              }
            }
          });
        }
        if (countWeeklyContractHours > 1) {
          weeklyContractHours = this.i18n.t('comp.help.multiple');
        }
        if (countPaymentValue > 1) {
          paymentValue = this.i18n.t('comp.help.multiple');
        }

        let employeeSums = [0, 0, 0];
        let employeeWageTypeSums = {};
        let employeeRows = [];
        let employeeRowCount = 0;

        if (employee.addedForShowOnly && (!entry.options.showOnlySums || entry.options.employeeSums)) {
          body.push([{ content: employee.lastName + ", " + employee.firstName + " - " + employee.mdPersonnelId + " ; " + this.i18n.t('employee.data.weekHours') + ": " + weeklyContractHours + " ; " + paymentText + ": " + paymentValue + " EUR", colSpan: 7 }]);
        }

        for (let dayId in employee.days) {
          if (entry.options.employeeSelection == 1 || entry.options.employeeSelection == 2) {
            if (employmentModelRowCount === 0 && employmentModel.model && (!entry.options.showOnlySums || entry.options.employeeSums || entry.options.employmentModelSums)) {
              body.push([{content: employmentModel.model.name, colSpan: 7 }]);
              employmentModelRowCount++;
            }
            if (employeeRowCount === 0 && (!entry.options.showOnlySums || entry.options.employeeSums)) {
              body.push([{ content: employee.lastName + ", " + employee.firstName + " - " + employee.mdPersonnelId + " ; " + this.i18n.t('employee.data.weekHours') + ": " + weeklyContractHours + " ; " + paymentText + ": " + paymentValue + " EUR", colSpan: 7 }]);
              if (exportJson.errors && "85" in exportJson.errors && exportJson.errors["85"].includes(employee.id)) {
                body.push([{
                  content: this.i18n.t('comp.help.avgValuesMissingSingle'),
                  colSpan: 7,
                  styles: {fillColor: [200, 0, 0], textColor: [255, 255, 255]}
                }]);
              }
              employeeRowCount++;
            }

          }

          let day = employee.days[dayId];
          if (day.wageTypes.length < 1) {
            continue;
          }

          for (let wageTypeCounter in day.wageTypes) {

            let wageType = day.wageTypes[wageTypeCounter];

            // MS1-6438: moved this up here to not print employee names if there are no wageTypes
            if (!wageType || (!entry.options.wageTypesBool && !entry.options.wageTypes.includes(wageType.id))) {
              // console.log("skip wageType " + wageType.id + " because it is not selected");
              continue;
            }

            if (employmentModelRowCount === 0 && employmentModel.model && (!entry.options.showOnlySums || entry.options.employeeSums || entry.options.employmentModelSums)) {
              body.push([{content: employmentModel.model.name, colSpan: 7 }]);
              employmentModelRowCount++;
            }
            if (employeeRowCount === 0 && (!entry.options.showOnlySums || entry.options.employeeSums)) {
              body.push([{ content: employee.lastName + ", " + employee.firstName + " - " + employee.mdPersonnelId + " ; " + this.i18n.t('employee.data.weekHours') + ": " + weeklyContractHours + " ; " + paymentText + ": " + paymentValue + " EUR", colSpan: 7 }]);
              if (exportJson.errors && "85" in exportJson.errors && exportJson.errors["85"].includes(employee.id)) {
                body.push([{ content: this.i18n.t('comp.help.avgValuesMissingSingle'), colSpan: 7, styles: { fillColor: [200, 0, 0], textColor: [255, 255, 255] } }]);
              }
              employeeRowCount++;
            }

            let payment = (wageType.hours && wageType.factor) ? parseFloat(wageType.hours) * parseFloat(wageType.factor) : 0;
            employeeRows.push([
              this.getMomentFromString(day.date,'YYYY-MM-DD').format('DD.MM.YYYY'),
              wageType.obj.numberString,
              wageType.obj.name,
              wageType.shifts,
              wageType.hours ? parseFloat(wageType.hours).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : "0.00",
              wageType.factor ? parseFloat(wageType.factor).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : "0.00",
              payment.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            ]);

            if (!wageType.hasOwnProperty('includeInSum') || wageType.includeInSum) {
              employeeSums[0] += wageType.shifts;
              employeeSums[1] += wageType.hours;
            }
            employeeSums[2] += payment;

            if (!employeeWageTypeSums.hasOwnProperty(wageType.obj.numberString)) {
              employeeWageTypeSums[wageType.obj.numberString] = { name: wageType.obj.name, numberString: wageType.obj.numberString, sums: [0, 0, 0] };
            }
            employeeWageTypeSums[wageType.obj.numberString].sums[0] += wageType.shifts;
            employeeWageTypeSums[wageType.obj.numberString].sums[1] += wageType.hours;
            employeeWageTypeSums[wageType.obj.numberString].sums[2] += payment;

            if (!wageType.hasOwnProperty('includeInSum') || wageType.includeInSum) {
              employmentModelSums[0] += wageType.shifts;
              employmentModelSums[1] += wageType.hours;
            }
            employmentModelSums[2] += payment;

            if (!employmentModelWageTypeSums.hasOwnProperty(wageType.obj.numberString)) {
              employmentModelWageTypeSums[wageType.obj.numberString] = { name: wageType.obj.name, numberString: wageType.obj.numberString, sums: [0, 0, 0] };
            }
            employmentModelWageTypeSums[wageType.obj.numberString].sums[0] += wageType.shifts;
            employmentModelWageTypeSums[wageType.obj.numberString].sums[1] += wageType.hours;
            employmentModelWageTypeSums[wageType.obj.numberString].sums[2] += payment;

            if (!wageType.hasOwnProperty('includeInSum') || wageType.includeInSum) {
              totalSums[0] += wageType.shifts;
              totalSums[1] += wageType.hours;
            }
            totalSums[2] += payment;

            if (!totalWageTypeSums.hasOwnProperty(wageType.obj.numberString)) {
              totalWageTypeSums[wageType.obj.numberString] = { name: wageType.obj.name, numberString: wageType.obj.numberString, sums: [0, 0, 0] };
            }
            totalWageTypeSums[wageType.obj.numberString].sums[0] += wageType.shifts;
            totalWageTypeSums[wageType.obj.numberString].sums[1] += wageType.hours;
            totalWageTypeSums[wageType.obj.numberString].sums[2] += payment;
          }
        }

        employeeRows.sort((a, b) => {
          if (entry.options.sortEntriesBy === 0) {
            if (a[1] > b[1]) {
              return 1;
            } else if (a[1] < b[1]) {
              return -1;
            } else {
              if (a[0] > b[0]) {
                return 1;
              } else {
                return -1;
              }
            }
          } else {
            if (a[0] > b[0]) {
              return 1;
            } else if (a[0] < b[0]) {
              return -1;
            } else {
              if (a[1] > b[1]) {
                return 1;
              } else {
                return -1;
              }
            }
          }
        });

        if (!entry.options.showOnlySums) {
          body.push(...employeeRows);
        }
        if (entry.options.employeeSums) {
          if (employeeRowCount > 0) {
            if (Object.keys(employeeWageTypeSums).length > 0 && entry.options.wageTypeSums) {
              Object.values(employeeWageTypeSums).forEach((value) => {
                body.push([
                  this.i18n.t('export.builder.sum') + ' ' + employee.firstName + " " + employee.lastName,
                  value.numberString,
                  value.name,
                  value.sums[0].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
                  value.sums[1].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
                  "",
                  value.sums[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                ]);
              });
            }
            body.push([
              this.i18n.t('export.builder.sum') + ' ' + employee.firstName + " " + employee.lastName,
              "",
              "",
              employeeSums[0].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
              employeeSums[1].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
              "",
              employeeSums[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            ]);
            body.push([]);
          }

          if (employee.addedForShowOnly) {
            body.push([
              this.i18n.t('export.builder.sum') + ' ' + employee.firstName + " " + employee.lastName,
              "",
              "",
              parseInt("0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
              parseInt("0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
              "",
              parseInt("0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            ]);
            body.push([]);
          }
        } else if (!entry.options.showOnlySums) {
          body.push([]);
        }
      }

      if (employmentModelRowCount > 0 && entry.options.employmentModelSums && employmentModel.model) {
        if (Object.keys(employmentModelWageTypeSums).length > 0 && entry.options.wageTypeSums) {
          Object.values(employmentModelWageTypeSums).forEach((value) => {
            body.push([
              this.i18n.t('export.builder.sum') + ' ' + employmentModel.model.name,
              value.numberString,
              value.name,
              value.sums[0].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
              value.sums[1].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
              "",
              value.sums[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            ]);
          });
        }
        body.push([
          this.i18n.t('export.builder.sum') + ' ' + employmentModel.model.name,
          "",
          "",
          employmentModelSums[0].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
          employmentModelSums[1].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
          "",
          employmentModelSums[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        ]);
        body.push([]);
      }

    };

    if (entry.options.totalSums) {
      if (Object.keys(totalWageTypeSums).length > 0 && entry.options.wageTypeSums) {
        Object.values(totalWageTypeSums).forEach((value) => {
          body.push([
            this.i18n.t('comp.help.sumTotal'),
            value.numberString,
            value.name,
            value.sums[0].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
            value.sums[1].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
            "",
            value.sums[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
          ]);
        });
      }
      body.push([
        this.i18n.t('comp.help.sumTotal'),
        "",
        "",
        totalSums[0].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
        totalSums[1].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
        "",
        totalSums[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      ]);
    }


    doc.autoTable(
        {
          startY: contentOffsetY,
          head: [headers],
          body: body,
          headStyles: {
            fillColor: [229,21,80],
            fontSize: 7,
            font: 'DistrictPro'
          },
          bodyStyles: {
            fontSize: 7,
            font: 'DistrictPro'
          },
          columnStyles: {
          },
          didParseCell: (data) => {
            if (data.section === 'body' && [1, 3, 4, 5, 6].includes(data.column.dataKey) && data.cell.raw !== undefined) {
              data.cell.styles.halign = 'right';
            }
            if (data.section === 'body' && data.cell.raw !== undefined && !(typeof data.cell.raw === 'object')
                && ((data.cell.raw + "").includes(this.i18n.t('export.builder.sum')) || (data.row.cells[0].raw + "").includes(this.i18n.t('export.builder.sum')))) {
              data.cell.styles.fontStyle = 'bold';
            }
            if (data.section === 'body' && data.cell.raw !== undefined && data.row.cells[1] === undefined) {
              data.cell.styles.fontStyle = 'bold';
            }
          },
          didDrawCell: (data) => {
          }
        }
    );
    return [doc, filename];
  }

  openCreateIndividualWageTypeExportPdfPopup(employmentModels, wageTypes, selectCallback) {
    let view = this;
    let dataEntries = [];
    view.getPdfOptions(employmentModels, wageTypes).forEach(option => {
      dataEntries.push(option);
    });

    let errorCheck = {};
    dataEntries.forEach(dataEntry => {
      if (dataEntry.key) {
        errorCheck[dataEntry.key] = (entries) => {
          let entry = entries[dataEntry.key];
          if (entry === '' || entry === undefined || entry === null || (Array.isArray(entry) && entry.length === 0))
            return {
              key: dataEntry.key,
              type: "error",
              text: dataEntry.label + " " + this.i18n.t('comp.help.mustBeSelected'),
            };
          else return null;
        };
      }
    });

    this.OpenPopup({
      elRelative: null,
      type: 'datafill',
      pointerDirection: 0,
      componentState: {
        entries: dataEntries,
        selectCallback: selectCallback,
        errorCheck: errorCheck
      },
      width: "700px",
      header: this.i18n.t('comp.help.pdfReportSettings'),
      remainAfterSelect: false,
      expanded: true,
      centered: true,
    });
  }

  createExportTemplate(softwareId, stores, wageTypes, employmentModels) {
    // console.log("stores", stores);
    let templates = [];
    let softwareTemplates = [];
    if (softwareId == 1) {
      // DPW Bruttoabrechnung Vorlage
      let monthly = JSON.parse('{"name":"DPW Bruttoabrechnung Vorlage","locked":false,"availableFields":[{"key":"externalCompanyId","name":"Betrieb ID","newName":"Firma","checked":true,"fieldOrder":1},{"key":"externalEmployeeId","name":"Mitarbeiter ID","newName":"Personalnr","checked":true,"fieldOrder":2},{"key":"lohnart","name":"Lohnart","newName":"Lohnart","checked":true,"fieldOrder":3},{"key":"paidWorkTime","name":"Ausbezahlter Wert","newName":"Einheit","checked":true,"fieldOrder":4},{"key":"placeholder1","name":"Platzhalter 1","newName":"Satz","fixedValue":"0","deleteable":true,"checked":true,"fieldOrder":5},{"key":"placeholder2","name":"Platzhalter 2","newName":"Betrag","fixedValue":"0","deleteable":true,"checked":true,"fieldOrder":6},{"key":"placeholder3","name":"Platzhalter 3","newName":"Datum gültig ab","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":7},{"key":"placeholder4","name":"Platzhalter 4","newName":"Datum gültig bis","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":8},{"key":"placeholder5","name":"Platzhalter 5","newName":"Kostenstelle","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":9},{"key":"month","name":"Monat","newName":"Monat","checked":true,"fieldOrder":10},{"key":"placeholder6","name":"Platzhalter 6","newName":"Unterb. von","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":11},{"key":"placeholder7","name":"Platzhalter 7","newName":"Unterb. bis","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":12},{"key":"placeholder8","name":"Platzhalter 8","newName":"Vorzeichen","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":13},{"key":"placeholder9","name":"Platzhalter 9","newName":"Tafel","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":14},{"key":"placeholder10","name":"Platzhalter 10","newName":"Gruppe","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":15},{"key":"placeholder11","name":"Platzhalter 11","newName":"KV Jahre","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":16},{"key":"placeholder12","name":"Platzhalter 12","newName":"Betragsvorgabe (J)","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":17},{"key":"placeholder13","name":"Platzhalter 13","newName":"Netto Code","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":18},{"key":"year","name":"Jahr","newName":"Jahr","checked":true,"fieldOrder":19},{"key":"placeholder14","name":"Platzhalter 14","newName":"ID","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":20},{"key":"placeholder15","name":"Platzhalter 15","newName":"Zus. Daten","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":21},{"key":"placeholder16","name":"Platzhalter 16","newName":"Kostenträger","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":22},{"key":"placeholder17","name":"Platzhalter 17","newName":"Bezeichnung NZ","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":23},{"key":"placeholder18","name":"Platzhalter 18","newName":"Bezeichnung NZ 2","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":24},{"key":"placeholder19","name":"Platzhalter 19","newName":"Land","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":25},{"key":"day","name":"Tag","newName":"Tag","checked":false,"fieldOrder":26},{"key":"rollUpMonth","name":"Aufrollmonat","newName":"Aufrollmonat","checked":false,"fieldOrder":27},{"key":"contentName","name":"Inhalt Bezeichnung","newName":"Inhalt","checked":false,"fieldOrder":28},{"key":"employeeName","name":"Mitarbeiter Name","newName":"Name","checked":false,"fieldOrder":29},{"key":"date","name":"Datum","newName":"Datum","checked":false,"fieldOrder":30},{"key":"costCenter","name":"Mitarbeiter Kostenstelle","newName":"Kostenstelle","checked":false,"fieldOrder":31},{"key":"factor","name":"Lohnsatz","newName":"Lohnsatz","checked":false,"fieldOrder":32},{"key":"hours","name":"Arbeitsstunden","newName":"Arbeitsstunden","checked":false,"fieldOrder":33},{"key":"payment","name":"Betrag","newName":"Betrag","checked":false,"fieldOrder":34},{"key":"unavailabilityCode","name":"Abwesenheitscode","newName":"Abwesenheitscode","checked":false,"fieldOrder":35},{"key":"days","name":"Tage","newName":"Tage","checked":false,"fieldOrder":36},{"key":"storeCostCenter","name":"Store Kostenstelle","newName":"Store Kostenstelle","checked":false,"fieldOrder":37},{"key":"processingKey","name":"Bearbeitungsschlüssel","newName":"Bearbeitungsschlüssel","checked":false,"fieldOrder":38},{"key":"daysCalculated","name":"Tage Äquivalent","newName":"Tage Äquivalent","checked":false,"fieldOrder":39},{"key":"date2","name":"Datum 2","newName":"Datum 2","checked":false,"fieldOrder":40},{"key":"taxId","name":"Steuernummer","newName":"Steuernummer","checked":false,"fieldOrder":41}],"availableFieldsAdditional":[{"key":"monthAdditional","name":"Monat","item":{"key":"current","label":"Aktueller Monat","selected":true},"checked":true},{"key":"rollUpMonthAdditional","name":"Aufrollmonat","item":{"key":"current","label":"Aktueller Monat"},"checked":false},{"key":"paidWorkTimeAdditional","name":"Ausbezahlter Wert","item":{"key":1,"label":"Keine Null Werte exportieren"},"checked":true}],"selectedStores":[],"selectedWageTypes":[],"selectedEmploymentModels":[],"availableFieldsIndividualWageTypesListAdditional":[{"key":"headerAdditional","name":"Kopfzeile","item":{"key":0,"label":"Spaltenbezeichnungen nicht andrucken"},"checked":true},{"key":"sumsAdditional","name":"Summen","item":{"key":2,"label":"Monatliche Summen bilden","selected":true},"checked":true},{"key":"zeroValuesAdditional","name":"Nullwerte","item":{"key":0,"label":"Keine Null Werte exportieren","selected":true},"checked":true},{"key":"absencesAdditional","name":"Abwesenheiten","item":{"key":0,"label":"Standard","selected":true},"checked":true},{"key":"mergeAdditional","name":"Lohnarten zusammenhängen","item":{"key":0,"label":"Alle Lohnarten einzeln exportieren","selected":true},"checked":true},{"key":"shiftsAdditional","name":"Schichten","item":{"key":2,"label":"Nur Ist-Schichten exportieren"},"checked":true},{"key":"calcModeAdditional","name":"Berechnungsmodus","item":{"key":1,"label":"Tag der Leistung"},"checked":true},{"key":"deltaAdditional","name":"Veränderungen seit letztem Export","item":{"key":1,"label":"Letzte Exportwerte nicht berücksichtigen","selected":true},"checked":true},{"key":"processingKeyAdditionalHours","name":"Bearbeitungsschlüssel Stunden/Tage/Anzahl","fixedValue":"1","checked":true},{"key":"processingKeyAdditionalValue","name":"Bearbeitungsschlüssel Betrag","fixedValue":"3","checked":true},{"key":"addAdditional","name":"Platzhalter einfügen","checked":true}]}');
      softwareTemplates.push(monthly);
      // DPW ABW Vorlage
      let absences = JSON.parse('{"name":"DPW ABW Vorlage","locked":false,"availableFields":[{"key":"externalCompanyId","name":"Betrieb ID","newName":"fnr","checked":true,"fieldOrder":1},{"key":"externalEmployeeId","name":"Mitarbeiter ID","newName":"pnr","checked":true,"fieldOrder":2},{"key":"lohnart","name":"Lohnart","newName":"abwcode","checked":true,"fieldOrder":3},{"key":"date","name":"Datum","newName":"von","checked":true,"fieldOrder":4},{"key":"placeholder1","name":"Platzhalter 1","newName":"std","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":5},{"key":"days","name":"Tage","newName":"tage","checked":true,"fieldOrder":6},{"key":"placeholder2","name":"Platzhalter 2","newName":"besch","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":7},{"key":"placeholder3","name":"Platzhalter 3","newName":"buchart","fixedValue":"B","deleteable":true,"checked":true,"fieldOrder":8},{"key":"placeholder4","name":"Platzhalter 4","newName":"strkende","fixedValue":"0","deleteable":true,"checked":true,"fieldOrder":9},{"key":"paidWorkTime","name":"Ausbezahlter Wert","newName":"Ausbezahlter Wert","checked":false,"fieldOrder":10},{"key":"day","name":"Tag","newName":"Tag","checked":false,"fieldOrder":11},{"key":"month","name":"Monat","newName":"Monat","checked":false,"fieldOrder":12},{"key":"rollUpMonth","name":"Aufrollmonat","newName":"Aufrollmonat","checked":false,"fieldOrder":13},{"key":"contentName","name":"Inhalt Bezeichnung","newName":"Inhalt","checked":false,"fieldOrder":14},{"key":"employeeName","name":"Mitarbeiter Name","newName":"Name","checked":false,"fieldOrder":15},{"key":"costCenter","name":"Mitarbeiter Kostenstelle","newName":"Kostenstelle","checked":false,"fieldOrder":16},{"key":"factor","name":"Lohnsatz","newName":"Lohnsatz","checked":false,"fieldOrder":17},{"key":"hours","name":"Arbeitsstunden","newName":"Arbeitsstunden","checked":false,"fieldOrder":18},{"key":"payment","name":"Betrag","newName":"Betrag","checked":false,"fieldOrder":19},{"key":"year","name":"Jahr","newName":"Jahr","checked":false,"fieldOrder":20},{"key":"unavailabilityCode","name":"Abwesenheitscode","newName":"Abwesenheitscode","checked":false,"fieldOrder":21},{"key":"storeCostCenter","name":"Store Kostenstelle","newName":"Store Kostenstelle","checked":false,"fieldOrder":22},{"key":"processingKey","name":"Bearbeitungsschlüssel","newName":"Bearbeitungsschlüssel","checked":false,"fieldOrder":23},{"key":"daysCalculated","name":"Tage Äquivalent","newName":"Tage Äquivalent","checked":false,"fieldOrder":24},{"key":"date2","name":"Datum 2","newName":"Datum 2","checked":false,"fieldOrder":25},{"key":"taxId","name":"Steuernummer","newName":"Steuernummer","checked":false,"fieldOrder":26}],"availableFieldsAdditional":[{"key":"monthAdditional","name":"Monat","item":{"key":"current","label":"Aktueller Monat","selected":true},"checked":true},{"key":"rollUpMonthAdditional","name":"Aufrollmonat","item":{"key":"current","label":"Aktueller Monat"},"checked":false},{"key":"paidWorkTimeAdditional","name":"Ausbezahlter Wert","item":{"key":1,"label":"Keine Null Werte exportieren"},"checked":true}],"selectedStores":[],"selectedWageTypes":[],"selectedEmploymentModels":[],"availableFieldsIndividualWageTypesListAdditional":[{"key":"headerAdditional","name":"Kopfzeile","item":{"key":0,"label":"Spaltenbezeichnungen nicht andrucken","selected":true},"checked":true},{"key":"sumsAdditional","name":"Summen","item":{"key":0,"label":"Tägliche Summen bilden","selected":true},"checked":true},{"key":"zeroValuesAdditional","name":"Nullwerte","item":{"key":0,"label":"Keine Null Werte exportieren","selected":true},"checked":true},{"key":"absencesAdditional","name":"Abwesenheiten","item":{"key":0,"label":"Standard","selected":true},"checked":true},{"key":"mergeAdditional","name":"Lohnarten zusammenhängen","item":{"key":0,"label":"Alle Lohnarten einzeln exportieren","selected":true},"checked":true},{"key":"shiftsAdditional","name":"Schichten","item":{"key":2,"label":"Nur Ist-Schichten exportieren"},"checked":true},{"key":"calcModeAdditional","name":"Berechnungsmodus","item":{"key":1,"label":"Tag der Leistung"},"checked":true},{"key":"deltaAdditional","name":"Veränderungen seit letztem Export","item":{"key":1,"label":"Letzte Exportwerte nicht berücksichtigen","selected":true},"checked":true},{"key":"processingKeyAdditionalHours","name":"Bearbeitungsschlüssel Stunden/Tage/Anzahl","fixedValue":"1","checked":true},{"key":"processingKeyAdditionalValue","name":"Bearbeitungsschlüssel Betrag","fixedValue":"3","checked":true},{"key":"addAdditional","name":"Platzhalter einfügen","checked":true}]}');
      softwareTemplates.push(absences);
    }
    if (softwareId == 3) {
      let template = JSON.parse('{"name":"Agenda Vorlage","locked":false,"availableFields":[{"key":"externalEmployeeId","name":"Mitarbeiter ID","newName":"Personalnr.","checked":true,"fieldOrder":1},{"key":"lohnart","name":"Lohnart","newName":"Lohnart","checked":true,"fieldOrder":2},{"key":"placeholder1","name":"Platzhalter 1","newName":"Lohnsatz","fixedValue":null,"deleteable":true,"checked":true,"fieldOrder":3},{"key":"factor","name":"Lohnsatz","newName":"Lohnsatz","checked":false,"fieldOrder":4},{"key":"paidWorkTime","name":"Ausbezahlter Wert","newName":"Wert","checked":true,"fieldOrder":5},{"key":"costCenter","name":"Mitarbeiter Kostenstelle","newName":"Kostenstelle","checked":true,"fieldOrder":6},{"key":"externalCompanyId","name":"Betrieb ID","newName":"Firma","checked":false,"fieldOrder":7},{"key":"month","name":"Monat","newName":"Monat","checked":false,"fieldOrder":8},{"key":"rollUpMonth","name":"Aufrollmonat","newName":"Aufrollmonat","checked":false,"fieldOrder":9},{"key":"contentName","name":"Inhalt Bezeichnung","newName":"Inhalt","checked":false,"fieldOrder":10},{"key":"employeeName","name":"Mitarbeiter Name","newName":"Name","checked":false,"fieldOrder":11},{"key":"date","name":"Datum","newName":"Datum","checked":false,"fieldOrder":12},{"key":"hours","name":"Arbeitsstunden","newName":"Arbeitsstunden","checked":false,"fieldOrder":13},{"key":"payment","name":"Betrag","newName":"Betrag","checked":false,"fieldOrder":14},{"key":"year","name":"Jahr","newName":"Jahr","checked":false,"fieldOrder":15},{"key":"day","name":"Tag","newName":"Tag","checked":false,"fieldOrder":16},{"key":"unavailabilityCode","name":"Abwesenheitscode","newName":"Abwesenheitscode","checked":false,"fieldOrder":17},{"key":"days","name":"Tage","newName":"Tage","checked":false,"fieldOrder":18},{"key":"storeCostCenter","name":"Store Kostenstelle","newName":"Store Kostenstelle","checked":false,"fieldOrder":19},{"key":"processingKey","name":"Bearbeitungsschlüssel","newName":"Bearbeitungsschlüssel","checked":false,"fieldOrder":20},{"key":"daysCalculated","name":"Tage Äquivalent","newName":"Tage Äquivalent","checked":false,"fieldOrder":21},{"key":"date2","name":"Datum 2","newName":"Datum 2","checked":false,"fieldOrder":22},{"key":"taxId","name":"Steuernummer","newName":"Steuernummer","checked":false,"fieldOrder":23}],"availableFieldsAdditional":[{"key":"monthAdditional","name":"Monat","item":{"key":"current","label":"Aktueller Monat"},"checked":true},{"key":"rollUpMonthAdditional","name":"Aufrollmonat","item":{"key":"current","label":"Aktueller Monat"},"checked":false},{"key":"paidWorkTimeAdditional","name":"Ausbezahlter Wert","item":{"key":1,"label":"Keine Null Werte exportieren"},"checked":true}],"selectedStores":[],"selectedWageTypes":[],"selectedEmploymentModels":[],"availableFieldsIndividualWageTypesListAdditional":[{"key":"headerAdditional","name":"Kopfzeile","item":{"key":1,"label":"Spaltenbezeichnungen andrucken","selected":true},"checked":true},{"key":"sumsAdditional","name":"Summen","item":{"key":2,"label":"Monatliche Summen bilden"},"checked":true},{"key":"zeroValuesAdditional","name":"Nullwerte","item":{"key":0,"label":"Keine Null Werte exportieren","selected":true},"checked":true},{"key":"absencesAdditional","name":"Abwesenheiten","item":{"key":0,"label":"Standard","selected":true},"checked":true},{"key":"mergeAdditional","name":"Lohnarten zusammenhängen","item":{"key":0,"label":"Alle Lohnarten einzeln exportieren"},"checked":true},{"key":"shiftsAdditional","name":"Schichten","item":{"key":2,"label":"Nur Ist-Schichten exportieren","selected":true},"checked":true},{"key":"calcModeAdditional","name":"Berechnungsmodus","item":{"key":1,"label":"Tag der Leistung"},"checked":true},{"key":"deltaAdditional","name":"Veränderungen seit letztem Export","item":{"key":1,"label":"Letzte Exportwerte nicht berücksichtigen"},"checked":true},{"key":"processingKeyAdditionalHours","name":"Bearbeitungsschlüssel Stunden/Tage/Anzahl","fixedValue":"1","checked":true},{"key":"processingKeyAdditionalValue","name":"Bearbeitungsschlüssel Betrag","fixedValue":"3","checked":true},{"key":"addAdditional","name":"Platzhalter einfügen","checked":true}]}');
      softwareTemplates.push(template);
    }
    if (softwareId == 4) {
      // let maladie = JSON.parse('{"name":"Gesper Vorlage Maladies","locked":false,"availableFields":[{"key":"externalCompanyId","name":"Betrieb ID","newName":"Firma","checked":false,"fieldOrder":9},{"key":"externalEmployeeId","name":"Mitarbeiter ID","newName":"Mitarbeiternummer","checked":true,"fieldOrder":3},{"key":"month","name":"Monat","newName":"Monat","checked":true,"fieldOrder":2},{"key":"rollUpMonth","name":"Aufrollmonat","newName":"Aufrollmonat","checked":false,"fieldOrder":10},{"key":"lohnart","name":"Lohnart","newName":"Lohnart","checked":true,"fieldOrder":7},{"key":"paidWorkTime","name":"Ausbezahlter Wert","newName":"Ausbezahlter Wert","checked":false,"fieldOrder":11},{"key":"contentName","name":"Inhalt Bezeichnung","newName":"Inhalt","checked":false,"fieldOrder":12},{"key":"employeeName","name":"Mitarbeiter Name","newName":"Name","checked":false,"fieldOrder":13},{"key":"date","name":"Datum","newName":"Datum","checked":false,"fieldOrder":14},{"key":"costCenter","name":"Mitarbeiter Kostenstelle","newName":"Kostenstelle","checked":false,"fieldOrder":15},{"key":"factor","name":"Lohnsatz","newName":"Lohnsatz","checked":false,"fieldOrder":16},{"key":"hours","name":"Arbeitsstunden","newName":"Arbeitsstunden","checked":true,"fieldOrder":5},{"key":"payment","name":"Betrag","newName":"Betrag","checked":false,"fieldOrder":17},{"key":"year","name":"Jahr","newName":"Jahr","checked":true,"fieldOrder":1},{"key":"day","name":"Tag","newName":"Tag","checked":true,"fieldOrder":6},{"key":"placeholder1","name":"Platzhalter 1","newName":"Salary Code","fixedValue":"M029","deleteable":true,"checked":true,"fieldOrder":4},{"key":"placeholder2","name":"Platzhalter 2","newName":"Disability code","fixedValue":"MAL","deleteable":true,"checked":true,"fieldOrder":8},{"key":"unavailabilityCode","name":"Abwesenheitscode","newName":"Abwesenheitscode","checked":false,"fieldOrder":18},{"key":"days","name":"Tage","newName":"Tage","checked":false,"fieldOrder":19},{"key":"storeCostCenter","name":"Store Kostenstelle","newName":"Store Kostenstelle","checked":false,"fieldOrder":20},{"key":"processingKey","name":"Bearbeitungsschlüssel","newName":"Bearbeitungsschlüssel","checked":false,"fieldOrder":21},{"key":"daysCalculated","name":"Tage Äquivalent","newName":"Tage Äquivalent","checked":false,"fieldOrder":22},{"key":"date2","name":"Datum 2","newName":"Datum 2","checked":false,"fieldOrder":23},{"key":"taxId","name":"Steuernummer","newName":"Steuernummer","checked":false,"fieldOrder":24}],"availableFieldsAdditional":[{"key":"monthAdditional","name":"Monat","item":{"key":"current","label":"Aktueller Monat"},"checked":true},{"key":"rollUpMonthAdditional","name":"Aufrollmonat","item":{"key":"current","label":"Aktueller Monat"},"checked":false},{"key":"paidWorkTimeAdditional","name":"Ausbezahlter Wert","item":{"key":1,"label":"Keine Null Werte exportieren"},"checked":true}],"selectedStores":[],"selectedWageTypes":[],"selectedEmploymentModels":[],"availableFieldsIndividualWageTypesListAdditional":[{"key":"headerAdditional","name":"Kopfzeile","item":{"key":0,"label":"Spaltenbezeichnungen nicht andrucken"},"checked":true},{"key":"sumsAdditional","name":"Summen","item":{"key":0,"label":"Tägliche Summen bilden","selected":true},"checked":true},{"key":"zeroValuesAdditional","name":"Nullwerte","item":{"key":0,"label":"Keine Null Werte exportieren","selected":true},"checked":true},{"key":"absencesAdditional","name":"Abwesenheiten","item":{"key":0,"label":"Standard","selected":true},"checked":true},{"key":"mergeAdditional","name":"Lohnarten zusammenhängen","item":{"key":0,"label":"Alle Lohnarten einzeln exportieren"},"checked":true},{"key":"shiftsAdditional","name":"Schichten","item":{"key":2,"label":"Nur Ist-Schichten exportieren","selected":true},"checked":true},{"key":"calcModeAdditional","name":"Berechnungsmodus","item":{"key":1,"label":"Tag der Leistung"},"checked":true},{"key":"deltaAdditional","name":"Veränderungen seit letztem Export","item":{"key":1,"label":"Letzte Exportwerte nicht berücksichtigen"},"checked":true},{"key":"processingKeyAdditionalHours","name":"Bearbeitungsschlüssel Stunden/Tage/Anzahl","fixedValue":"1","checked":true},{"key":"processingKeyAdditionalValue","name":"Bearbeitungsschlüssel Betrag","fixedValue":"3","checked":true},{"key":"addAdditional","name":"Platzhalter einfügen","checked":true}]}');
      // maladie.id = crypto.randomUUID();
      // templates.push(maladie);
      // Gesper Vorlage Pointages
      let template = JSON.parse('{"name":"Gesper Vorlage","locked":false,"availableFields":[{"key":"year","name":"Jahr","newName":"Jahr","checked":true,"fieldOrder":1},{"key":"month","name":"Monat","newName":"Monat","checked":true,"fieldOrder":2},{"key":"externalEmployeeId","name":"Mitarbeiter ID","newName":"Mitarbeiternummer","checked":true,"fieldOrder":3},{"key":"lohnart","name":"Lohnart","newName":"Lohnart","checked":true,"fieldOrder":4},{"key":"hours","name":"Arbeitsstunden","newName":"Arbeitsstunden","checked":true,"fieldOrder":5},{"key":"placeholder1","name":"Platzhalter 1","newName":"Type of registration","fixedValue":"R","deleteable":true,"checked":true,"fieldOrder":6},{"key":"day","name":"Tag","newName":"Tag","checked":false,"fieldOrder":7},{"key":"externalCompanyId","name":"Betrieb ID","newName":"Firma","checked":false,"fieldOrder":8},{"key":"rollUpMonth","name":"Aufrollmonat","newName":"Aufrollmonat","checked":false,"fieldOrder":9},{"key":"paidWorkTime","name":"Ausbezahlter Wert","newName":"Ausbezahlter Wert","checked":false,"fieldOrder":10},{"key":"contentName","name":"Inhalt Bezeichnung","newName":"Inhalt","checked":false,"fieldOrder":11},{"key":"employeeName","name":"Mitarbeiter Name","newName":"Name","checked":false,"fieldOrder":12},{"key":"date","name":"Datum","newName":"Datum","checked":false,"fieldOrder":13},{"key":"costCenter","name":"Mitarbeiter Kostenstelle","newName":"Kostenstelle","checked":false,"fieldOrder":14},{"key":"factor","name":"Lohnsatz","newName":"Lohnsatz","checked":false,"fieldOrder":15},{"key":"payment","name":"Betrag","newName":"Betrag","checked":false,"fieldOrder":16},{"key":"unavailabilityCode","name":"Abwesenheitscode","newName":"Abwesenheitscode","checked":false,"fieldOrder":17},{"key":"days","name":"Tage","newName":"Tage","checked":false,"fieldOrder":18},{"key":"storeCostCenter","name":"Store Kostenstelle","newName":"Store Kostenstelle","checked":false,"fieldOrder":19},{"key":"processingKey","name":"Bearbeitungsschlüssel","newName":"Bearbeitungsschlüssel","checked":false,"fieldOrder":20},{"key":"daysCalculated","name":"Tage Äquivalent","newName":"Tage Äquivalent","checked":false,"fieldOrder":21},{"key":"date2","name":"Datum 2","newName":"Datum 2","checked":false,"fieldOrder":22},{"key":"taxId","name":"Steuernummer","newName":"Steuernummer","checked":false,"fieldOrder":23}],"availableFieldsAdditional":[{"key":"monthAdditional","name":"Monat","item":{"key":"current","label":"Aktueller Monat"},"checked":true},{"key":"rollUpMonthAdditional","name":"Aufrollmonat","item":{"key":"current","label":"Aktueller Monat"},"checked":false},{"key":"paidWorkTimeAdditional","name":"Ausbezahlter Wert","item":{"key":1,"label":"Keine Null Werte exportieren"},"checked":true},{"key":"externalEmployeeIdAdditional","name":"Mitarbeiter ID","item":{"key":1,"label":"Fixe Länge: 4 Stellen"},"checked":true}],"selectedStores":[],"selectedWageTypes":[],"selectedEmploymentModels":[],"availableFieldsIndividualWageTypesListAdditional":[{"key":"headerAdditional","name":"Kopfzeile","item":{"key":0,"label":"Spaltenbezeichnungen nicht andrucken"},"checked":true},{"key":"sumsAdditional","name":"Summen","item":{"key":2,"label":"Monatliche Summen bilden","selected":true},"checked":true},{"key":"zeroValuesAdditional","name":"Nullwerte","item":{"key":0,"label":"Keine Null Werte exportieren","selected":true},"checked":true},{"key":"absencesAdditional","name":"Abwesenheiten","item":{"key":0,"label":"Standard","selected":true},"checked":true},{"key":"mergeAdditional","name":"Lohnarten zusammenhängen","item":{"key":0,"label":"Alle Lohnarten einzeln exportieren"},"checked":true},{"key":"shiftsAdditional","name":"Schichten","item":{"key":2,"label":"Nur Ist-Schichten exportieren","selected":true},"checked":true},{"key":"calcModeAdditional","name":"Berechnungsmodus","item":{"key":1,"label":"Tag der Leistung"},"checked":true},{"key":"deltaAdditional","name":"Veränderungen seit letztem Export","item":{"key":1,"label":"Letzte Exportwerte nicht berücksichtigen"},"checked":true},{"key":"processingKeyAdditionalHours","name":"Bearbeitungsschlüssel Stunden/Tage/Anzahl","fixedValue":"1","checked":true},{"key":"processingKeyAdditionalValue","name":"Bearbeitungsschlüssel Betrag","fixedValue":"3","checked":true},{"key":"addAdditional","name":"Platzhalter einfügen","checked":true}]}');
      softwareTemplates.push(template);
    }
    if (softwareId == 5) {
      let template = JSON.parse('{"name":"Lodas Vorlage","locked":false,"availableFields":[{"key":"date","name":"Datum","newName":"abrechnung_zeitraum#bwd","checked":true,"fieldOrder":1},{"key":"paidWorkTime","name":"Ausbezahlter Wert","newName":"bs_wert_butab#bwd","checked":true,"fieldOrder":2},{"key":"processingKey","name":"Bearbeitungsschlüssel","newName":"bs_nr#bwd","checked":true,"fieldOrder":3},{"key":"lohnart","name":"Lohnart","newName":"la_eigene#bwd","checked":true,"fieldOrder":4},{"key":"externalEmployeeId","name":"Mitarbeiter ID","newName":"pnr#bwd","checked":true,"fieldOrder":5},{"key":"storeCostCenter","name":"Store Kostenstelle","newName":"kostenstelle#bwd","checked":true,"fieldOrder":6},{"key":"externalCompanyId","name":"Betrieb ID","newName":"Firma","checked":false,"fieldOrder":7},{"key":"month","name":"Monat","newName":"Monat","checked":false,"fieldOrder":8},{"key":"rollUpMonth","name":"Aufrollmonat","newName":"Aufrollmonat","checked":false,"fieldOrder":9},{"key":"contentName","name":"Inhalt Bezeichnung","newName":"Inhalt","checked":false,"fieldOrder":10},{"key":"employeeName","name":"Mitarbeiter Name","newName":"Name","checked":false,"fieldOrder":11},{"key":"factor","name":"Lohnsatz","newName":"Lohnsatz","checked":false,"fieldOrder":12},{"key":"hours","name":"Arbeitsstunden","newName":"Arbeitsstunden","checked":false,"fieldOrder":13},{"key":"payment","name":"Betrag","newName":"Betrag","checked":false,"fieldOrder":14},{"key":"year","name":"Jahr","newName":"Jahr","checked":false,"fieldOrder":15},{"key":"day","name":"Tag","newName":"Tag","checked":false,"fieldOrder":16},{"key":"costCenter","name":"Mitarbeiter Kostenstelle","newName":"Kostenstelle","checked":false,"fieldOrder":17},{"key":"unavailabilityCode","name":"Abwesenheitscode","newName":"Abwesenheitscode","checked":false,"fieldOrder":18},{"key":"days","name":"Tage","newName":"Tage","checked":false,"fieldOrder":19},{"key":"daysCalculated","name":"Tage Äquivalent","newName":"Tage Äquivalent","checked":false,"fieldOrder":20},{"key":"date2","name":"Datum 2","newName":"Datum 2","checked":false,"fieldOrder":21},{"key":"taxId","name":"Steuernummer","newName":"Steuernummer","checked":false,"fieldOrder":22}],"availableFieldsAdditional":[{"key":"monthAdditional","name":"Monat","item":{"key":"current","label":"Aktueller Monat"},"checked":true},{"key":"rollUpMonthAdditional","name":"Aufrollmonat","item":{"key":"current","label":"Aktueller Monat"},"checked":false},{"key":"paidWorkTimeAdditional","name":"Ausbezahlter Wert","item":{"key":1,"label":"Keine Null Werte exportieren"},"checked":true}],"selectedStores":[],"selectedWageTypes":[],"selectedEmploymentModels":[],"availableFieldsIndividualWageTypesListAdditional":[{"key":"headerAdditional","name":"Kopfzeile","item":{"key":0,"label":"Spaltenbezeichnungen nicht andrucken","selected":true},"checked":true},{"key":"sumsAdditional","name":"Summen","item":{"key":2,"label":"Monatliche Summen bilden","selected":true},"checked":true},{"key":"zeroValuesAdditional","name":"Nullwerte","item":{"key":0,"label":"Keine Null Werte exportieren","selected":true},"checked":true},{"key":"absencesAdditional","name":"Abwesenheiten","item":{"key":0,"label":"Standard","selected":true},"checked":true},{"key":"mergeAdditional","name":"Lohnarten zusammenhängen","item":{"key":0,"label":"Alle Lohnarten einzeln exportieren"},"checked":true},{"key":"shiftsAdditional","name":"Schichten","item":{"key":2,"label":"Nur Ist-Schichten exportieren","selected":true},"checked":true},{"key":"calcModeAdditional","name":"Berechnungsmodus","item":{"key":1,"label":"Tag der Leistung"},"checked":true},{"key":"deltaAdditional","name":"Veränderungen seit letztem Export","item":{"key":1,"label":"Letzte Exportwerte nicht berücksichtigen"},"checked":true},{"key":"processingKeyAdditionalHours","name":"Bearbeitungsschlüssel Stunden/Tage/Anzahl","fixedValue":"1","checked":true},{"key":"processingKeyAdditionalValue","name":"Bearbeitungsschlüssel Betrag","fixedValue":"3","checked":true},{"key":"addAdditional","name":"Platzhalter einfügen","checked":true}]}');
      softwareTemplates.push(template);
    }
    if (softwareId == 6) {
      let template = JSON.parse('{"name":"Lohn und Gehalt Vorlage","locked":false,"availableFields":[{"key":"externalEmployeeId","name":"Mitarbeiter ID","newName":"Personalnummer","checked":true,"fieldOrder":1},{"key":"day","name":"Tag","newName":"Kalendertag","checked":true,"fieldOrder":2},{"key":"unavailabilityCode","name":"Abwesenheitscode","newName":"Ausfallschlüssel","checked":true,"fieldOrder":3},{"key":"lohnart","name":"Lohnart","newName":"Lohnartennummer","checked":true,"fieldOrder":4},{"key":"hours","name":"Arbeitsstunden","newName":"Stundenanzahl","checked":true,"fieldOrder":5},{"key":"days","name":"Tage","newName":"Tagesanzahl","checked":true,"fieldOrder":6},{"key":"paidWorkTime","name":"Ausbezahlter Wert","newName":"Wert","checked":true,"fieldOrder":7},{"key":"costCenter","name":"Mitarbeiter Kostenstelle","newName":"Kostenstellennummer","checked":true,"fieldOrder":8},{"key":"externalCompanyId","name":"Betrieb ID","newName":"Firma","checked":false,"fieldOrder":9},{"key":"month","name":"Monat","newName":"Monat","checked":false,"fieldOrder":10},{"key":"rollUpMonth","name":"Aufrollmonat","newName":"Aufrollmonat","checked":false,"fieldOrder":11},{"key":"contentName","name":"Inhalt Bezeichnung","newName":"Inhalt","checked":false,"fieldOrder":12},{"key":"employeeName","name":"Mitarbeiter Name","newName":"Name","checked":false,"fieldOrder":13},{"key":"date","name":"Datum","newName":"Datum","checked":false,"fieldOrder":14},{"key":"factor","name":"Lohnsatz","newName":"Lohnsatz","checked":false,"fieldOrder":15},{"key":"payment","name":"Betrag","newName":"Betrag","checked":false,"fieldOrder":16},{"key":"year","name":"Jahr","newName":"Jahr","checked":false,"fieldOrder":17},{"key":"storeCostCenter","name":"Store Kostenstelle","newName":"Store Kostenstelle","checked":false,"fieldOrder":18},{"key":"processingKey","name":"Bearbeitungsschlüssel","newName":"Bearbeitungsschlüssel","checked":false,"fieldOrder":19},{"key":"daysCalculated","name":"Tage Äquivalent","newName":"Tage Äquivalent","checked":false,"fieldOrder":20},{"key":"date2","name":"Datum 2","newName":"Datum 2","checked":false,"fieldOrder":21},{"key":"taxId","name":"Steuernummer","newName":"Steuernummer","checked":false,"fieldOrder":22}],"availableFieldsAdditional":[{"key":"monthAdditional","name":"Monat","item":{"key":"current","label":"Aktueller Monat"},"checked":true},{"key":"rollUpMonthAdditional","name":"Aufrollmonat","item":{"key":"current","label":"Aktueller Monat"},"checked":false},{"key":"paidWorkTimeAdditional","name":"Ausbezahlter Wert","item":{"key":1,"label":"Keine Null Werte exportieren"},"checked":true},{"key":"externalEmployeeIdAdditional","name":"Mitarbeiter ID","item":{"key":0,"label":"Ohne Änderung übernehmen"},"checked":true}],"selectedStores":[],"selectedWageTypes":[],"selectedEmploymentModels":[],"availableFieldsIndividualWageTypesListAdditional":[{"key":"headerAdditional","name":"Kopfzeile","item":{"key":0,"label":"Spaltenbezeichnungen nicht andrucken"},"checked":true},{"key":"sumsAdditional","name":"Summen","item":{"key":2,"label":"Monatliche Summen bilden"},"checked":true},{"key":"zeroValuesAdditional","name":"Nullwerte","item":{"key":0,"label":"Keine Null Werte exportieren","selected":true},"checked":true},{"key":"absencesAdditional","name":"Abwesenheiten","item":{"key":0,"label":"Standard","selected":true},"checked":true},{"key":"mergeAdditional","name":"Lohnarten zusammenhängen","item":{"key":0,"label":"Alle Lohnarten einzeln exportieren"},"checked":true},{"key":"shiftsAdditional","name":"Schichten","item":{"key":2,"label":"Nur Ist-Schichten exportieren","selected":true},"checked":true},{"key":"calcModeAdditional","name":"Berechnungsmodus","item":{"key":1,"label":"Tag der Leistung"},"checked":true},{"key":"deltaAdditional","name":"Veränderungen seit letztem Export","item":{"key":1,"label":"Letzte Exportwerte nicht berücksichtigen"},"checked":true},{"key":"processingKeyAdditionalHours","name":"Bearbeitungsschlüssel Stunden/Tage/Anzahl","fixedValue":"1","checked":true},{"key":"processingKeyAdditionalValue","name":"Bearbeitungsschlüssel Betrag","fixedValue":"3","checked":true},{"key":"addAdditional","name":"Platzhalter einfügen","checked":true}]}');
      softwareTemplates.push(template);
    }
    if (softwareId == 7) {
      let template = JSON.parse('{"name":"McD Slovenia Template","selectedStores":[],"availableFields":[{"key":"externalEmployeeId","name":"Mitarbeiter ID","newName":"Personal Number","checked":true,"fieldOrder":1},{"key":"lohnart","name":"Lohnart","newName":"Wagetype ID","checked":true,"fieldOrder":2},{"key":"paidWorkTime","name":"Ausbezahlter Wert","newName":"Hours","checked":true,"fieldOrder":3},{"key":"placeholder1","name":"export.builder.placeholder1","newName":"Days","fixedValue":"00000000","deleteable":true,"checked":true,"fieldOrder":4},{"key":"placeholder2","name":"export.builder.placeholder2","newName":"Placeholder","fixedValue":"0000","deleteable":true,"checked":true,"fieldOrder":5},{"key":"costCenter","name":"Mitarbeiter Kostenstelle","newName":"Cost centre","checked":true,"fieldOrder":6},{"key":"placeholder3","name":"export.builder.placeholder3","newName":"Amount","fixedValue":"00000000000000","deleteable":true,"checked":true,"fieldOrder":7},{"key":"payment","name":"Betrag","newName":"Amount_2","checked":true,"fieldOrder":8},{"key":"days","name":"Tage","newName":"Days","checked":false,"fieldOrder":9},{"key":"hours","name":"Arbeitsstunden","newName":"Hours","checked":false,"fieldOrder":10},{"key":"taxId","name":"Steuernummer","newName":"Personal Number","checked":false,"fieldOrder":11},{"key":"daysCalculated","name":"Tage Äquivalent","newName":"Tage Äquivalent","checked":false,"fieldOrder":12},{"key":"externalCompanyId","name":"Betrieb ID","newName":"Firma","checked":false,"fieldOrder":13},{"key":"month","name":"Monat","newName":"Monat","checked":false,"fieldOrder":14},{"key":"rollUpMonth","name":"Aufrollmonat","newName":"Aufrollmonat","checked":false,"fieldOrder":15},{"key":"date","name":"Datum","newName":"Datum","checked":false,"fieldOrder":16},{"key":"date2","name":"Datum 2","newName":"Datum 2","checked":false,"fieldOrder":17},{"key":"contentName","name":"Inhalt Bezeichnung","newName":"Inhalt","checked":false,"fieldOrder":18},{"key":"employeeName","name":"Mitarbeitername","newName":"Name","checked":false,"fieldOrder":19},{"key":"factor","name":"Lohnsatz","newName":"Lohnsatz","checked":false,"fieldOrder":20},{"key":"year","name":"Jahr","newName":"Jahr","checked":false,"fieldOrder":21},{"key":"day","name":"Tag","newName":"Tag","checked":false,"fieldOrder":22},{"key":"unavailabilityCode","name":"Abwesenheitscode","newName":"Abwesenheitscode","checked":false,"fieldOrder":23},{"key":"storeCostCenter","name":"Store Kostenstelle","newName":"Store Kostenstelle","checked":false,"fieldOrder":24},{"key":"processingKey","name":"Bearbeitungsschlüssel","newName":"Bearbeitungsschlüssel","checked":false,"fieldOrder":25}],"availableFieldsAdditional":[{"key":"monthAdditional","name":"Monat","item":{"key":"current","label":"Aktueller Monat"},"checked":true},{"key":"rollUpMonthAdditional","name":"Aufrollmonat","item":{"key":"current","label":"Aktueller Monat"},"checked":false},{"key":"externalEmployeeIdAdditional","name":"Mitarbeiter ID","item":{"key":0,"label":"Ohne Änderung übernehmen"},"checked":true},{"key":"paidWorkTimeAdditional","name":"Ausbezahlter Wert","item":{"key":1,"label":"Keine Null Werte exportieren"},"checked":true}],"selectedEmploymentModels":[],"availableFieldsIndividualWageTypesListAdditional":[{"key":"headerAdditional","name":"Listenaufbau","item":{"key":0,"label":"Spaltenbezeichnungen nicht andrucken"},"checked":true,"fixedValue":"","hidden":false},{"key":"sumsAdditional","name":"Summen","item":{"key":2,"label":"Monatliche Summen bilden","selected":true},"checked":true,"fixedValue":"","hidden":false},{"key":"zeroValuesAdditional","name":"Nullwerte","item":{"key":0,"label":"Keine Null Werte exportieren","selected":true},"checked":true,"fixedValue":"","hidden":false},{"key":"absencesAdditional","name":"Abwesenheiten","item":{"key":0,"label":"Standard"},"checked":true,"fixedValue":"","hidden":true},{"key":"mergeAdditional","name":"Lohnarten zusammenhängen","item":{"key":1,"label":"Lohnarten mit gleicher Export ID zusammenfassen","selected":true},"checked":true,"fixedValue":"","hidden":false},{"key":"shiftsAdditional","name":"Schichten","item":{"key":2,"label":"Nur Ist-Schichten exportieren","selected":true},"checked":true,"fixedValue":"","hidden":false},{"key":"calcModeAdditional","name":"Berechnungsmodus","item":{"key":2,"label":"Tag des Schichtbeginns","selected":true},"checked":true,"fixedValue":"","hidden":false},{"key":"deltaAdditional","name":"Veränderungen seit letztem Export","item":{"key":1,"label":"Letzte Exportwerte nicht berücksichtigen"},"checked":true,"fixedValue":"","hidden":false},{"key":"processingKeyAdditionalHours","name":"Bearbeitungsschlüssel Stunden/Tage/Anzahl","fixedValue":"1","checked":true,"hidden":true},{"key":"processingKeyAdditionalValue","name":"Bearbeitungsschlüssel Betrag","fixedValue":"3","checked":true,"hidden":true},{"key":"addAdditional","name":"Platzhalter einfügen","checked":true,"fixedValue":"","hidden":false}],"selectedWageTypes":[]}');
      softwareTemplates.push(template);
    }
    if (stores && stores.length > 0) {
      stores.forEach(s => {
        softwareTemplates.forEach(t => {
          let storeTemplate = JSON.parse(JSON.stringify(t));
          storeTemplate.selectedStores.push(s.id);
          storeTemplate.name = storeTemplate.name + " " + s.name;
          storeTemplate.id = crypto.randomUUID();
          storeTemplate.selectedWageTypes = wageTypes;
          storeTemplate.selectedEmploymentModels = employmentModels;
          templates.push(storeTemplate);
        });
      });
    } else {
      softwareTemplates.forEach(t => {
        t.id = crypto.randomUUID();
        t.selectedWageTypes = wageTypes;
        t.selectedEmploymentModels = employmentModels;
        templates.push(t);
      });
    }
    return templates;
  }
  createLohnUndGehaltFieldDescriptionFile(setting) {

    // [Allgemein]
    // Feldanzahl = 8
    // Feldtrennzeichen = Strichpunkt
    // Satztrennzeichen = Enter/Return
    // Zahlenkomma = .
    // Datumstrennzeichen = /

    // [Feldinhalt]
    // Feld1 = Personalnummer
    // Feld2 = Kalendertag
    // Feld3 = Ausfallschlüssel
    // Feld4 = Lohnartennummer
    // Feld5 = Stundenanzahl
    // Feld6 = Tagesanzahl
    // Feld7 = Wert
    // Feld8 = Kostenstellennummer

    let text = "[Allgemein]\r\n";
    text += this.i18n.t('comp.help.fieldCount') + " = " + setting.availableFields.filter(f => f.checked).length + "\r\n";
    text += this.i18n.t('comp.help.fieldSeparator') + " = Strichpunkt\r\n";
    text += this.i18n.t('comp.help.recordSeparator') + " = Enter/Return\r\n";
    text += this.i18n.t('comp.help.decimalSeparator') + " = .\r\n";
    text += this.i18n.t('comp.help.dateSeparator') + " = /\r\n\r\n";
    text += "[Feldinhalt]\r\n";

    let fieldOrder = 1;
    setting.availableFields
        .filter(f => f.checked)
        .sort((a, b) => a.fieldOrder - b.fieldOrder)
        .forEach(field => {
          if (field.newName !== null && field.newName !== undefined) {
            text += this.i18n.t('employee.export.field') + fieldOrder + " = " + field.newName + "\r\n";
          }
          fieldOrder++;
        });

    return "\uFEFF" + text;
  }

  getEmployeeContractMapByRemoteId(force = false, asArray = false) {
    let view = this;

    return view.GetEmployeeContractMap(force)
    .then(resp => {
      return view.GetStores(force)
        .then(storeResponse => {
          let storeIds = storeResponse.map(s => s.id);
          let contractsByRemoteId = {};
          Object.values(resp).forEach(contract => {
            if (storeIds.includes(contract.storeId)) {
              if (contractsByRemoteId.hasOwnProperty(contract.remoteId)) {
                contractsByRemoteId[contract.remoteId].push(contract);
              } else {
                contractsByRemoteId[contract.remoteId] = [];
                contractsByRemoteId[contract.remoteId].push(contract);
              }
            }
          });
          return new Promise((resolve, reject) => {
            resolve(this.returnObj(contractsByRemoteId, asArray));
          });
        });
    }).catch(e => {
      return new Promise((resolve, reject) => {
        reject(e);
      });
    });
  }
  getPdfOptions(employmentModels, wageTypes, hideContentSelection = false) {
    let view = this;

    let selectAllEmploymentModels = localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions") ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).employmentModelsBool : false;
    let selectAllWagetypes = localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions") ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).wageTypesBool : false;

    let employeeSelectionItems = [
      {
        label: this.i18n.t('comp.help.allEmployees'),
        value: 1
      },
      {
        label: this.i18n.t('comp.help.allEmployeesWithActiveContract'),
        value: 2
      },
      {
        label: this.i18n.t('comp.help.onlyEmployeesWithSelectedValues'),
        value: 3
      }
    ];

    let groupByLocalStorage = localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions") ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).groupBy : null;
    let groupByItems = [
      {
        label: this.i18n.t('comp.help.noGrouping'),
        value: 0
      },
      {
        label: this.i18n.t('comp.help.groupByEmploymentGroup'),
        value: 1
      }
    ];
    let groupBySelectedItem = groupByLocalStorage != null ? groupByItems.find(e => e.value == groupByLocalStorage) : groupByItems.find(e => e.value == 0);

    let sortEmployeesByLocalStorage = localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions") ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).sortEmployeesBy : null;
    let sortEmployeesByItems = [
      {
        label: this.i18n.t('comp.help.sortByLastName'),
        value: 0
      },
      {
        label: this.i18n.t('comp.help.sortByPersonnelNumber'),
        value: 1
      }
    ];
    let sortEmployeesBySelectedItem = sortEmployeesByLocalStorage != null ? sortEmployeesByItems.find(e => e.value == sortEmployeesByLocalStorage) : sortEmployeesByItems.find(e => e.value == 0);

    let sortEntriesByLocalStorage = localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions") ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).sortEntriesBy : null;
    let sortEntriesByItems = [
      {
        label: this.i18n.t('comp.help.sortByEarnCode'),
        value: 0
      },
      {
        label: this.i18n.t('comp.help.sortByDate'),
        value: 1
      }
    ];
    let sortEntriesBySelectedItem = sortEntriesByLocalStorage != null ? sortEntriesByItems.find(e => e.value == sortEntriesByLocalStorage) : sortEntriesByItems.find(e => e.value == 0);

    let showSumsAtTopLocalStorage = localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions") ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).showSumsAtTop : null;
    let showSumsAtTopItems = [
      {
        label: this.i18n.t('comp.help.sumsAtEnd'),
        value: 0
      },
      {
        label: this.i18n.t('comp.help.sumsAtStart'),
        value: 1
      }
    ];
    let showSumsAtTopSelectedItem = showSumsAtTopLocalStorage != null ? showSumsAtTopItems.find(e => e.value == showSumsAtTopLocalStorage) : showSumsAtTopItems.find(e => e.value == 0);

    return [
      {
        label: this.i18n.t('comp.help.grouping'),
        key: "groupBy",
        hidden: false,
        type: "dropdownsearch",
        value: 0,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: groupByItems,
          selectMultiple: false,
          selectFirst: false,
          selectedItems: [],
          selectedItem: groupBySelectedItem,
          styleLight: true
        }
      },
      {
        label: this.i18n.t('comp.help.employeeSorting'),
        key: "sortEmployeesBy",
        hidden: false,
        type: "dropdownsearch",
        value: 0,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: sortEmployeesByItems,
          selectMultiple: false,
          selectFirst: false,
          selectedItems: [],
          selectedItem: sortEmployeesBySelectedItem,
          styleLight: true
        }
      },
      {
        label: this.i18n.t('comp.help.entrySorting'),
        key: "sortEntriesBy",
        hidden: false,
        type: "dropdownsearch",
        value: 0,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: sortEntriesByItems,
          selectMultiple: false,
          selectFirst: false,
          selectedItems: [],
          selectedItem: sortEntriesBySelectedItem,
          styleLight: true
        }
      },
      {
        label: this.i18n.t('comp.help.positionOfSums'),
        key: "showSumsAtTop",
        hidden: false,
        type: "dropdownsearch",
        value: 0,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: showSumsAtTopItems,
          selectMultiple: false,
          selectFirst: false,
          selectedItems: [],
          selectedItem: showSumsAtTopSelectedItem,
          styleLight: true
        }
      },
      {
        label: this.i18n.t('comp.help.employeeSelection'),
        key: "employeeSelection",
        hidden: false,
        type: "dropdownsearch",
        value: null,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: employeeSelectionItems,
          selectedItem:
              localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")
              && JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).employeeSelection
                  ? employeeSelectionItems.find(e => e.value == JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).employeeSelection)
                  : employeeSelectionItems.find(e => e.value == 3),
          selectMultiple: false,
          onceSelected: function ($event, item, searchbar) {},
          styleLight: true,
          placeholder: this.i18n.t('settings.help.pleaseSelect'),
        },
      },
      {
        label: this.i18n.t('comp.help.allEmploymentGroups'),
        key: "employmentModelsBool",
        hidden: hideContentSelection,
        type: "bool",
        value: !hideContentSelection && selectAllEmploymentModels,
        computed: (datafill, lastVal, entryBeforeUpdate) => {
          let useExportSettings = datafill.entries.find(i => i.key == 'useExportSettings');
          if (useExportSettings && useExportSettings.value == true) {
            entryBeforeUpdate.hidden = true;
            entryBeforeUpdate.value = false;
          } else {
            entryBeforeUpdate.hidden = false;
          }
          return entryBeforeUpdate;
        }
      },
      {
        label: this.i18n.t('comp.help.deselectAllEmploymentGroups'),
        key: "employmentModelDeselectBool",
        hidden: hideContentSelection || selectAllEmploymentModels,
        type: "bool",
        value: false,
        computed: (datafill, lastVal, entryBeforeUpdate) => {
          let employmentModelsBool = datafill.entries.find(i => i.key == 'employmentModelsBool');
          let useExportSettings = datafill.entries.find(i => i.key == 'useExportSettings');
          if ((useExportSettings && useExportSettings.value == true) || employmentModelsBool.value == true) {
            entryBeforeUpdate.hidden = true;
            entryBeforeUpdate.value = false;
          } else {
            entryBeforeUpdate.hidden = false;
          }
          return entryBeforeUpdate;
        }
      },
      {
        label: this.i18n.t('comp.help.employmentGroups'),
        key: "employmentModels",
        hidden: hideContentSelection || selectAllEmploymentModels,
        type: "dropdownsearch",
        value: null,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: view.getPdfOptionsEmploymentModelsLocalStorage(employmentModels),
          selectMultiple: true,
          onceSelected: function ($event, item, searchbar) {
            let employmentModelDeselectBool = searchbar.$parent.entries.find(i => i.key == 'employmentModelDeselectBool');
            employmentModelDeselectBool.value = false;
          },
          styleLight: true,
          placeholder: this.i18n.t('settings.help.pleaseSelect'),
        },
        computed: (datafill, lastVal, entryBeforeUpdate) => {
          let employmentModelsBool = datafill.entries.find(i => i.key == 'employmentModelsBool');
          let useExportSettings = datafill.entries.find(i => i.key == 'useExportSettings');
          let employmentModelDeselectBool = datafill.entries.find(i => i.key == 'employmentModelDeselectBool');
          if ((useExportSettings && useExportSettings.value == true) || employmentModelsBool.value == true) {
            entryBeforeUpdate.hidden = true;
            entryBeforeUpdate.dropdownSearchState.items = employmentModels.map(m => ({
              value: m.id,
              label: m.name,
              selected: true
            }));
          } else {
            entryBeforeUpdate.hidden = false;
            if (employmentModelDeselectBool.value == true) {
              entryBeforeUpdate.dropdownSearchState.items = employmentModels.map(m => ({
                value: m.id,
                label: m.name,
                selected: false
              }));
            }
          }
          return entryBeforeUpdate;
        }
      },
      {
        label: this.i18n.t('comp.help.allWageTypes'),
        key: "wageTypesBool",
        hidden: hideContentSelection,
        type: "bool",
        value: !hideContentSelection && selectAllWagetypes,
        computed: (datafill, lastVal, entryBeforeUpdate) => {
          let useExportSettings = datafill.entries.find(i => i.key == 'useExportSettings');
          if (useExportSettings && useExportSettings.value == true) {
            entryBeforeUpdate.hidden = true;
            entryBeforeUpdate.value = false;
          } else {
            entryBeforeUpdate.hidden = false;
          }
          return entryBeforeUpdate;
        }
      },
      {
        label: this.i18n.t('comp.help.deselectAllWageTypes'),
        key: "wageTypesDeselectBool",
        hidden: hideContentSelection || selectAllWagetypes,
        type: "bool",
        value: false,
        computed: (datafill, lastVal, entryBeforeUpdate) => {
          let wageTypesBool = datafill.entries.find(i => i.key == 'wageTypesBool');
          let useExportSettings = datafill.entries.find(i => i.key == 'useExportSettings');
          if ((useExportSettings && useExportSettings.value == true) || wageTypesBool.value == true) {
            entryBeforeUpdate.hidden = true;
            entryBeforeUpdate.value = false;
          } else {
            entryBeforeUpdate.hidden = false;
          }
          return entryBeforeUpdate;
        }
      },
      {
        label: this.i18n.t('comp.help.wageTypes'),
        key: "wageTypes",
        hidden: hideContentSelection || selectAllWagetypes,
        type: "dropdownsearch",
        value: null,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: view.getPdfOptionsWageTypesLocalStorage(wageTypes),
          selectMultiple: true,
          onceSelected: function ($event, item, searchbar) {
            let wageTypesDeselectBool = searchbar.$parent.entries.find(i => i.key == 'wageTypesDeselectBool');
            wageTypesDeselectBool.value = false;
          },
          styleLight: true,
          placeholder: this.i18n.t('settings.help.pleaseSelect'),
        },
        computed: (datafill, lastVal, entryBeforeUpdate) => {
          let wageTypesBool = datafill.entries.find(i => i.key == 'wageTypesBool');
          let useExportSettings = datafill.entries.find(i => i.key == 'useExportSettings');
          let wageTypesDeselectBool = datafill.entries.find(i => i.key == 'wageTypesDeselectBool');
          if ((useExportSettings && useExportSettings.value == true) || wageTypesBool.value == true) {
            entryBeforeUpdate.hidden = true;
            entryBeforeUpdate.dropdownSearchState.items = wageTypes.map(m => ({
              value: m.id,
              label: m.name,
              selected: true
            }));
          } else {
            entryBeforeUpdate.hidden = false;
            if (wageTypesDeselectBool.value == true) {
              entryBeforeUpdate.dropdownSearchState.items = wageTypes.map(m => ({
                value: m.id,
                label: m.name,
                selected: false
              }));
            }
          }
          return entryBeforeUpdate;
        }
      },
      {
        label: this.i18n.t('comp.help.showOnlySums'),
        key: "showOnlySums",
        hidden: false,
        type: "bool",
        value: localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")
            ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).showOnlySums
            : false,
      },
      {
        label: this.i18n.t('comp.help.employeeSums'),
        key: "employeeSums",
        hidden: false,
        type: "bool",
        value: localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")
            ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).employeeSums
            : true,
      },
      {
        label: this.i18n.t('comp.help.employmentModelSums'),
        key: "employmentModelSums",
        hidden: false,
        type: "bool",
        value: localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")
            ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).employmentModelSums
            : true,
      },
      {
        label: this.i18n.t('comp.help.wageTypeSums'),
        key: "wageTypeSums",
        hidden: false,
        type: "bool",
        value: localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")
            ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).wageTypeSums
            : true,
      },
      {
        label: this.i18n.t('comp.help.totalSums'),
        key: "totalSums",
        hidden: false,
        type: "bool",
        value: localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")
            ? JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions")).totalSums
            : true,
      }
    ];
  }
  getPdfOptionsEmploymentModelsLocalStorage(models) {
    let pdfOptionsLocalStorage = JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions"));
    let employmentModelsLocalStorage = pdfOptionsLocalStorage ? pdfOptionsLocalStorage.employmentModels : [];

    return models.map(m => (
        {
          value: m.id,
          label: m.name,
          selected: employmentModelsLocalStorage.length > 0 ? employmentModelsLocalStorage.includes(m.id) : true
        }
    ));
  }
  getPdfOptionsWageTypesLocalStorage(wageTypes) {
    let pdfOptionsLocalStorage = JSON.parse(localStorage.getItem(this.store.state.companyId + "_settings_sotecDashboard_pdfOptions"));
    let wageTypesLocalStorage = pdfOptionsLocalStorage ? pdfOptionsLocalStorage.wageTypes : [];

    return wageTypes.map(wt => (
        {
          value: wt.id,
          label: wt.name,
          selected: wageTypesLocalStorage.length > 0 ? wageTypesLocalStorage.includes(wt.id) : true
        }
    ));
  }

  generateBmdExportSumsPDF(exportEntries, storeArray, month, year, userFullname) {

    // console.log(storeArray);

    let headers = [
      { content: this.i18n.t('comp.help.wageTypeLabel'), colSpan: 1, styles: { halign: 'left' } },
      { content: this.i18n.t('comp.help.wageTypeBmd'), colSpan: 1, styles: { halign: 'center' } },
      { content: this.i18n.t('comp.help.days'), colSpan: 1, styles: { halign: 'right' } },
      { content: this.i18n.t('comp.help.hours'), colSpan: 1, styles: { halign: 'right' } }
    ];

    let created_at = this.getMomentTZ().format("YYYY-MM-DD_HH-mm-ss");
    let filename = this.i18n.t('comp.help.bmdExportTotals') + this.store.state.companyData.label + "_" + this.monthName(month - 1) + ' ' + year + created_at + '.pdf';
    let repDoc = this.tableReportDoc(
        headers,
        this.i18n.t('comp.help.costCenterReport') + this.monthName(month - 1) + ' ' + year,
        this.store.state.companyData.label,
        "",
        userFullname,
        9
    );
    let doc = repDoc.doc;
    doc.setProperties({
      title: this.i18n.t('comp.help.costCenterReport')
    });
    let contentOffsetY = repDoc.contentOffsetY;
    doc.setFontSize(10);
    doc.setFont(DistrictProBold.fontId, DistrictProBold.fontStyle);

    let firstPage = true;

    Object.entries(exportEntries).sort(([keyA, valueA], [keyB, valueB]) => {
      return keyA - keyB;
    }).forEach(([key, entries]) => {
      if (Object.keys(entries).length > 0) {
        let x = 14;
        let y = contentOffsetY;
        if (firstPage) {
          firstPage = false;
        } else {
          doc.addPage();
          y = 20;
        }

        let store = storeArray.find(s => s.id == key);
        if (store) {
          doc.text(store.name + ", " + store.description, x, y);
        } else if (key == "sum") {
          doc.text(this.i18n.t('export.builder.sum'), x, y);
        } else {
          doc.text(this.i18n.t('comp.help.unknownLocation') + key, x, y);
        }

        let body = [];
        let monthlyEntries = Object.entries(entries).filter(([key, value]) => value.hasOwnProperty("lohnart"));
        if (monthlyEntries.length > 0) {
          body.push([this.i18n.t('comp.help.monthlyTotals')]);
          monthlyEntries.forEach(([key, value]) => {
            body.push([
              key,
              value.lohnart,
              "",
              value.paidWorkTime.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            ]);
          });
        }
        let dailyEntries = Object.entries(entries).filter(([key, value]) => !value.hasOwnProperty("lohnart"));
        if (dailyEntries.length > 0) {
          if (monthlyEntries.length > 0) {
            body.push([]);
          }
          body.push([this.i18n.t('comp.help.absences')]);
          dailyEntries.forEach(([key, value]) => {
            body.push([
              key,
              value.dailyLohnart,
              value.dailyPayoutValue,
              value.dailyPayoutHoursValue.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            ]);
          });
        }

        doc.autoTable(
          {
            startY: y + 2,
            head: [headers],
            body: body,
            headStyles: {
              fillColor: [229,21,80],
              fontSize: 7,
              font: 'DistrictPro'
            },
            bodyStyles: {
              fontSize: 7,
              font: 'DistrictPro'
            },
            columnStyles: {
            },
            didParseCell: (data) => {
              if (data.section === 'body' && [2,3].includes(data.column.dataKey) && data.cell.raw !== undefined) {
                data.cell.styles.halign = 'right';
              }
              if (data.section === 'body' && [1].includes(data.column.dataKey) && data.cell.raw !== undefined) {
                data.cell.styles.halign = 'center';
              }
              if (data.section === 'body' && [0].includes(data.column.dataKey) && data.row.cells[2].raw === undefined) {
                data.cell.styles.fontStyle = 'bold';
              }
            },
            didDrawCell: (data) => {
            }
          });
      }

    });

    return [doc, filename];
  }

  generateBmdExportSumsCSV(exportEntries, storeArray, month, year, dailyValuesCSV) {
    let lines = [];

    let headers = [
      this.i18n.t('report.comp.company'),
      this.i18n.t('comp.help.costCenter'),
      this.i18n.t('comp.help.wageTypeBmd'),
      this.i18n.t('settings.centers.desc'),
      this.i18n.t('comp.help.value')
    ];

    lines.push(headers.join(";"));

    let filename = this.i18n.t('comp.help.bmdExportTotals') + this.store.state.companyData.label + "_" + this.monthName(month - 1) + ' ' + year + '.csv';

    Object.entries(exportEntries).sort(([keyA, valueA], [keyB, valueB]) => {
      return keyA - keyB;
    }).forEach(([key, entries]) => {
      if (Object.keys(entries).length > 0) {

        let store = storeArray.find(s => s.id == key);
        if (!store) {
          console.log("store not found for id " + key);
          return;
        }
        let storeSetting = this.store.state.storesSettings.data.find(s => s.id == store.id);
        if (!storeSetting) {
          console.log("storeSetting not found for id " + store.id);
          return;
        }
        // console.log("storeSetting", storeSetting);
        let splitCostCenter = storeSetting.costCenter ? storeSetting.costCenter.split(",") : "";
        let costCenter = splitCostCenter.length > 0 ? splitCostCenter[0] : ""; // use "main" cost center for export

        let monthlyEntries = Object.entries(entries).filter(([key, value]) => value.hasOwnProperty("lohnart"));
        if (monthlyEntries.length > 0) {
          monthlyEntries.forEach(([key, value]) => {
            lines.push(
              (this.store.state.companySettings.data[0].bmdId ?? "") + ";"
              + (costCenter) + ";"
              + (value.lohnart ?? "") + ";"
              + (key ?? "") + ";"
              + (value.paidWorkTime ? value.paidWorkTime.toString().replace(".", ",") : "0")
            );
          });
        }
        let dailyEntries = Object.entries(entries).filter(([key, value]) => !value.hasOwnProperty("lohnart"));
        if (dailyEntries.length > 0) {
          dailyEntries.forEach(([key, value]) => {
            lines.push(
              (this.store.state.companySettings.data[0].bmdId ?? "") + ";"
              + (costCenter) + ";"
              + (value.dailyLohnart ?? "") + ";"
              + (key ?? "") + ";"
              + (
                dailyValuesCSV == 1
                  ? (value.dailyPayoutValue ?? "0")
                  : (value.dailyPayoutHoursValue ? value.dailyPayoutHoursValue.toString().replace(".", ",") : "0")
              )
            );
          });
        }
      }

    });

    return [lines.join('\n'), filename];
  }

  getEldaInsurerArray() {
    return [
      {
        value: "03",
        label: "Sozialversicherungsanstalt der Selbständigen",
      },
      {
        value: "05",
        label: "BVAEB",
      },
      {
        value: "08",
        label: "Allgemeine Unfallversicherungsanstalt",
      },
      {
        value: "11",
        label: "ÖGK Wien",
      },
      {
        value: "12",
        label: "ÖGK Niederösterreich",
      },
      {
        value: "13",
        label: "ÖGK Burgenland",
      },
      {
        value: "14",
        label: "ÖGK Oberösterreich",
      },
      {
        value: "15",
        label: "ÖGK Steiermark",
      },
      {
        value: "16",
        label: "ÖGK Kärnten",
      },
      {
        value: "17",
        label: "ÖGK Salzburg",
      },
      {
        value: "18",
        label: "ÖGK Tirol",
      },
      {
        value: "19",
        label: "ÖGK Vorarlberg",
      },
      {
        value: "24",
        label: "Betriebskrankenkasse Mondi",
      },
      {
        value: "25",
        label: "Betriebskrankenkasse voestalpine Bahnsysteme",
      },
      {
        value: "26",
        label: "Betriebskrankenkasse Zeltweg",
      },
      {
        value: "28",
        label: "Betriebskrankenkasse Kapfenberg",
      },
      {
        value: "1A",
        label: "KFA der Bediensteten der Stadt Wien",
      },
      {
        value: "4A",
        label: "KFA der Landeshauptstadt Linz",
      },
      {
        value: "4B",
        label: "Kranken- und Unfallfürsorgeträger der OÖ Gemeinden",
      },
      {
        value: "4C",
        label: "Kranken- und Unfallfürsorgeträger für OÖ Landesbedienstete",
      },
      {
        value: "4D",
        label: "OÖ Lehrer-Kranken- und Unfallfürsorge",
      },
      {
        value: "4E",
        label: "KFA der Beamten der Stadt Steyr",
      },
      {
        value: "4F",
        label: "KFA der Stadt Wels",
      },
      {
        value: "5A",
        label: "KFA der Landeshauptstadt Graz",
      },
      {
        value: "6A",
        label: "KFA der Stadt Villach",
      },
      {
        value: "7A",
        label: "KFA der MagistratsbeamtInnen der Stadt Salzburg",
      },
      {
        value: "7C",
        label: "KF d. pragmatisierten Bediensteten der Stadt Hallein",
      },
      {
        value: "94",
        label: "Bundesrechenzentrum GmbH",
      },
      {
        value: "99",
        label: "Dachverband der österreichischen Sozialversicherungen",
      },
      {
        value: "ST",
        label: "Statistik Austria",
      },
      {
        value: "MO",
        label: "Tabak – Monopolverwaltung GmbH",
      },
      {
        value: "A0",
        label: "Bundesarbeitskammer",
      },
    ];
  }
  getEldaProjektArray() {
    return [
      {
        value: "TM",
        label: "Testmeldung",
      },
      {
        value: "DM",
        label: "Dienstgebermeldung",
      }
    ]
  }

  GetEldaEmployerSettings(force = false, asArray = false) {
    if (this.store.state.eldaEmployerSettingsMap && this.store.state.eldaEmployerSettingsMap.companyId == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
          resolve(this.returnObj(this.store.state.eldaEmployerSettingsMap, asArray));
      });
    } else {
      let map = {};
      let params = {};
      return this.GetCall('/api/sec/elda/settings/employer', params)
      .then((response) => {
        map = response.data;

        this.store.commit('setEldaEmployerSettingsMap', {
          eldaEmployerSettingsMap: map
        });
        return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
        });
      }).catch((e) => {
          this.store.commit('setEldaEmployerSettingsMap', {
            eldaEmployerSettingsMap: {
              companyId: this.store.state.companyId,
              name: '',
              phone_number: '',
              email: '',
              insurer: []
            }
          });
          return new Promise((resolve, reject) => {
              reject(e);
          });
      });
    }
  }
  GetEldaCreatorSettings(force = false, asArray = false) {
    if (this.store.state.eldaCreatorSettingsMap && this.store.state.eldaCreatorSettingsMapState && this.store.state.eldaCreatorSettingsMapState.companyId == this.store.state.companyId && !force) {
      return new Promise((resolve, reject) => {
          resolve(this.returnObj(this.store.state.eldaCreatorSettingsMap, asArray));
      });
    } else {
      let map = {};
      let params = {};
      return this.GetCall('/api/sec/elda/settings/creator', params)
      .then((response) => {
        map = response.data;

        this.store.commit('setEldaCreatorSettingsMap', {
          eldaCreatorSettingsMap: map
        });
        return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
        });
      }).catch((e) => {
          return new Promise((resolve, reject) => {
              reject(e);
          });
      });
    }
  }
  GetEldaRequestTypes(force = false, asArray = false) {
    if (this.store.state.eldaRequestTypesMapState && this.store.state.eldaRequestTypesMapState.loaded == true && !force) {
      return new Promise((resolve, reject) => {
          resolve(this.returnObj(this.store.state.eldaRequestTypesMap, asArray));
      });
    } else {
      let map = {};
      let params = {};
      return this.GetCall('/api/sec/elda/request/types', params)
      .then((response) => {
        map = response.data;

        this.store.commit('setEldaRequestTypesMap', {
          eldaRequestTypesMap: map
        });
        return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
        });
      }).catch((e) => {
          return new Promise((resolve, reject) => {
              reject(e);
          });
      });
    }
  }
  GetEldaRequestFields(requestType, force = false, asArray = false) {
    if (this.store.state.eldaRequestFieldsMapState && this.store.state.eldaRequestFieldsMapState[requestType] && !force) {
      return new Promise((resolve, reject) => {
          resolve(this.returnObj(this.store.state.eldaRequestFieldsMap[requestType], asArray));
      });
    } else {
      let map = {};
      let params = {
        requestType: requestType
      };
      return this.GetCall('/api/sec/elda/request/fields', params)
      .then((response) => {
        map = response.data;

        this.store.commit('setEldaRequestFieldsMap', {
          requestType: requestType,
          eldaRequestFieldsMap: map
        });
        return new Promise((resolve, reject) => {
            resolve(this.returnObj(map, asArray));
        });
      }).catch((e) => {
          return new Promise((resolve, reject) => {
              reject(e);
          });
      });
    }
  }
  GetMdEmployeeAvailabilityTypes() {
    return [
        { value: 1, label: this.i18n.t('settings.wage.availabilityVacation') },
        { value: 2, label: this.i18n.t('settings.wage.availabilitySick') },
        { value: 3, label: this.i18n.t('settings.wage.availabilityHolidayCompensation') },
        { value: 4, label: this.i18n.t('settings.wage.availabilityOther') },
        // { value: 5, label: this.i18n.t('settings.wage.availabilityNoContract') },
        { value: 6, label: this.i18n.t('settings.wage.availabilityPersonal') },
        { value: 7, label: this.i18n.t('settings.wage.availabilityTraining') },
        { value: 8, label: this.i18n.t('settings.wage.availabilityContinuedPay') }
    ];
  }
  GetMdEmployeeAvailabilitySubTypes() {
    return [
        // { value: -1, parentType: 2, label: this.i18n.t('settings.wage.avsNoDetail') }, // deprecated, mapped to 22/23
        { value: 1, parentType: 8, label: this.i18n.t('settings.wage.avsOther') },
        { value: 2, parentType: 6, label: this.i18n.t('settings.wage.avsWedding') },
        { value: 3, parentType: 6, label: this.i18n.t('settings.wage.avsDeath') },
        { value: 4, parentType: 6, label: this.i18n.t('settings.wage.avsFuneral') },
        { value: 5, parentType: 6, label: this.i18n.t('settings.wage.avsChildBirth') },
        { value: 6, parentType: 6, label: this.i18n.t('settings.wage.avsRelocation') },
        { value: 7, parentType: 8, label: this.i18n.t('settings.wage.avsMilitaryService') },
        { value: 8, parentType: 8, label: this.i18n.t('settings.wage.avsWorkAccident') },
        { value: 9, parentType: 8, label: this.i18n.t('settings.wage.avsDoctorVisit') },
        { value: 10, parentType: 8, label: this.i18n.t('settings.wage.avsAuthoritySummons') },
        { value: 11, parentType: 8, label: this.i18n.t('settings.wage.avsQuarantine') },
        { value: 12, parentType: 4, label: this.i18n.t('settings.wage.avsTimeCompensation') },
        { value: 13, parentType: 2, label: this.i18n.t('settings.wage.avsSickNoCertificate') },
        { value: 14, parentType: 6, label: this.i18n.t('settings.wage.avsBirthday') },
        { value: 15, parentType: 4, label: this.i18n.t('settings.wage.avsUnjustifiedAbsence') },
        { value: 16, parentType: 4, label: this.i18n.t('settings.wage.avsUnpaidLeave') },
        { value: 17, parentType: 4, label: this.i18n.t('settings.wage.avsLeaveOfAbsence') },
        { value: 18, parentType: 8, label: this.i18n.t('settings.wage.avsOfficeDay') },
        { value: 19, parentType: 8, label: this.i18n.t('settings.wage.avsHomeOffice') },
        { value: 20, parentType: 8, label: this.i18n.t('settings.wage.avsHolidayPay') },
        { value: 21, parentType: 2, label: this.i18n.t('settings.wage.avsStateSickPay') },
        { value: 22, parentType: 2, label: this.i18n.t('settings.wage.avsRegularSickLeave') },
        { value: 23, parentType: 4, label: this.i18n.t('settings.wage.avsNoDetail') },
        { value: 24, parentType: 4, label: this.i18n.t('settings.wage.avsFreeAccordingToRoster') },
        { value: 25, parentType: 8, label: this.i18n.t('settings.wage.avsOnCallDuty') },
        { value: 26, parentType: 8, label: this.i18n.t('settings.wage.avsActiveTravelTime') },
        { value: 27, parentType: 4, label: this.i18n.t('settings.wage.avsTravelTimeNoCredit') },
        { value: 28, parentType: 8, label: this.i18n.t('settings.wage.avsPassiveTravelTime') },
        { value: 29, parentType: 8, label: this.i18n.t('settings.wage.avsBusinessTrip') },
        { value: 30, parentType: 6, label: this.i18n.t('settings.wage.avsCareLeave') },
        { value: 31, parentType: 6, label: this.i18n.t('settings.wage.avsImportantPersonalLeave') },
        { value: 32, parentType: 6, label: this.i18n.t('settings.wage.avsParentalLeave') },
        { value: 33, parentType: 6, label: this.i18n.t('settings.wage.avsMaternityProtection') },
        { value: 34, parentType: 6, label: this.i18n.t('settings.wage.avsNursingBreak') },
        { value: 35, parentType: 8, label: this.i18n.t('settings.wage.avsOtherSpecialLeave') },
        { value: 36, parentType: 8, label: this.i18n.t('settings.wage.avsCivilProtection') },
        { value: 37, parentType: 8, label: this.i18n.t('settings.wage.avsFireFighting') },
        { value: 38, parentType: 8, label: this.i18n.t('settings.wage.avsReleaseFromDuties') },
        { value: 39, parentType: 2, label: this.i18n.t('settings.wage.avsSickWithinWaitPeriod') },
        { value: 40, parentType: 6, label: this.i18n.t('settings.wage.avsKidSchool') },
    ];
  }
}
